import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { fetchSharedAccessQuery, urlSearchParamPreviewPerspective, urlSearchParamVercelProtectionBypass, urlSearchParamVercelSetBypassCookie, schemaIdSingleton, schemaTypeSingleton, schemaType } from "@sanity/preview-url-secret/constants";
import { Text, Stack, Inline, Box, Flex, Container as Container$1, Card, Code, Label, TextInput, Spinner, useToast, Menu, Grid, Switch, MenuDivider, Hotkeys, usePrefersReducedMotion, BoundaryElementProvider } from "@sanity/ui";
import { uuid } from "@sanity/uuid";
import { memo, useEffect, useRef, useContext, useLayoutEffect, useState, forwardRef, Suspense, useId, lazy, useMemo, useCallback, useImperativeHandle, useSyncExternalStore, startTransition, useReducer } from "react";
import { useTranslation, useUnique, getPublishedId, useDocumentPreviewStore, getPreviewStateObservable, useSchema, getPreviewValueWithFallback, SanityDefaultPreview, PreviewCard, Translate, CommentsIntentProvider, useActiveWorkspace, useClient, useCurrentUser, usePerspective, useProjectId, useDataset, useWorkspace, COMMENTS_INSPECTOR_NAME, useGrantsStore } from "sanity";
import { presentationLocaleNamespace, usePresentationTool, PresentationSpinner, API_VERSION, ACTION_IFRAME_RELOAD, MAX_TIME_TO_OVERLAYS_CONNECTION, ACTION_IFRAME_LOADED, POPUP_CHECK_INTERVAL, presentationReducer, presentationReducerInit, ACTION_VISUAL_EDITING_OVERLAYS_TOGGLE, ACTION_IFRAME_REFRESH, EDIT_INTENT_MODE, DEFAULT_TOOL_NAME } from "./presentation.mjs";
import { studioPath } from "@sanity/client/csm";
import { createController, createConnectionMachine } from "@sanity/comlink";
import { createCompatibilityActors } from "@sanity/presentation-comlink";
import { StateLink, useRouter, decodeJsonParams } from "sanity/router";
import { styled } from "styled-components";
import { useEffectEvent } from "use-effect-event";
import { PresentationSharedStateContext, PresentationPanelsContext, PresentationNavigateContext, PresentationParamsContext, PresentationContext } from "sanity/_singletons";
import { WarningOutlineIcon, LaunchIcon, ResetIcon, ShareIcon, CopyIcon, PanelLeftIcon, RefreshIcon, MobileDeviceIcon, DesktopIcon } from "@sanity/icons";
import { PaneRouterContext, PaneLayout, DocumentListPane as DocumentListPane$1, StructureToolProvider, DocumentPane as DocumentPane$1 } from "sanity/structure";
import { Button, ErrorBoundary, Tooltip, MenuButton, MenuItem, TooltipDelayGroupProvider } from "./TooltipDelayGroupProvider.mjs";
import "../_singletons.mjs";
import { DisplayedDocumentBroadcasterProvider } from "./DisplayedDocumentBroadcaster.mjs";
import { v4 } from "uuid";
import { motion, AnimatePresence, MotionConfig } from "framer-motion";
import { flushSync } from "react-dom";
import { setSecretSearchParams, withoutSecretSearchParams } from "@sanity/preview-url-secret/without-secret-search-params";
import { SanityMonogram } from "@sanity/logos";
import { disablePreviewAccessSharing, enablePreviewAccessSharing } from "@sanity/preview-url-secret/toggle-preview-access-sharing";
import { validateApiPerspective } from "@sanity/client";
import isEqual from "fast-deep-equal";
import { match } from "path-to-regexp";
import { pipe, string, minLength, optional, object, record, unknown } from "valibot";
import { createPreviewSecret } from "@sanity/preview-url-secret/create-secret";
import { definePreviewUrl } from "@sanity/preview-url-secret/define-preview-url";
import { suspend } from "suspend-react";
import { subcribeToVercelProtectionBypass } from "@sanity/preview-url-secret/toggle-vercel-protection-bypass";
const PostMessageFeatures = (props) => {
  const $ = c(3), {
    comlink
  } = props;
  let t0, t1;
  return $[0] !== comlink ? (t0 = () => comlink.on("visual-editing/features", _temp$7), t1 = [comlink], $[0] = comlink, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useEffect(t0, t1), null;
};
var PostMessageFeatures$1 = memo(PostMessageFeatures);
function _temp$7() {
  return {
    features: {
      optimistic: !0
    }
  };
}
function debounce(fn, timeout) {
  let timer;
  return (...args) => {
    clearTimeout(timer), timer = setTimeout(() => {
      fn.apply(fn, args);
    }, timeout);
  };
}
const SharedStateProvider = function(props) {
  const $ = c(14), {
    comlink,
    children
  } = props;
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {}, $[0] = t0) : t0 = $[0];
  const sharedState = useRef(t0);
  let t1, t2;
  $[1] !== comlink ? (t1 = () => comlink?.on("visual-editing/shared-state", () => ({
    state: sharedState.current
  })), t2 = [comlink], $[1] = comlink, $[2] = t1, $[3] = t2) : (t1 = $[2], t2 = $[3]), useEffect(t1, t2);
  let t3;
  $[4] !== comlink ? (t3 = (key, value) => {
    sharedState.current[key] = value, comlink?.post("presentation/shared-state", {
      key,
      value
    });
  }, $[4] = comlink, $[5] = t3) : t3 = $[5];
  const setValue = t3;
  let t4;
  $[6] !== comlink ? (t4 = (key_0) => {
    comlink?.post("presentation/shared-state", {
      key: key_0
    }), delete sharedState.current[key_0];
  }, $[6] = comlink, $[7] = t4) : t4 = $[7];
  const removeValue = t4;
  let t5, t6;
  $[8] !== removeValue || $[9] !== setValue ? (t6 = {
    removeValue,
    setValue
  }, $[8] = removeValue, $[9] = setValue, $[10] = t6) : t6 = $[10], t5 = t6;
  const context = t5;
  let t7;
  return $[11] !== children || $[12] !== context ? (t7 = /* @__PURE__ */ jsx(PresentationSharedStateContext.Provider, { value: context, children }), $[11] = children, $[12] = context, $[13] = t7) : t7 = $[13], t7;
}, Root$1 = styled.div`
  overflow: hidden;
  flex-basis: 0;
  flex-shrink: 1;
`, Panel = function(t0) {
  const $ = c(15), {
    children,
    defaultSize: t1,
    id,
    minWidth,
    maxWidth,
    order: t2
  } = t0, defaultSize = t1 === void 0 ? null : t1, order = t2 === void 0 ? 0 : t2, context = useContext(PresentationPanelsContext);
  if (context === null)
    throw Error("Panel components must be rendered within a PanelGroup container");
  const {
    getPanelStyle,
    registerElement,
    unregisterElement
  } = context;
  let t3;
  $[0] !== getPanelStyle || $[1] !== id ? (t3 = getPanelStyle(id), $[0] = getPanelStyle, $[1] = id, $[2] = t3) : t3 = $[2];
  const style = t3;
  let t4, t5;
  $[3] !== defaultSize || $[4] !== id || $[5] !== maxWidth || $[6] !== minWidth || $[7] !== order || $[8] !== registerElement || $[9] !== unregisterElement ? (t4 = () => (registerElement(id, {
    id,
    type: "panel",
    defaultSize,
    maxWidth: maxWidth ?? null,
    minWidth: minWidth ?? 0,
    order
  }), () => {
    unregisterElement(id);
  }), t5 = [id, defaultSize, order, maxWidth, minWidth, registerElement, unregisterElement], $[3] = defaultSize, $[4] = id, $[5] = maxWidth, $[6] = minWidth, $[7] = order, $[8] = registerElement, $[9] = unregisterElement, $[10] = t4, $[11] = t5) : (t4 = $[10], t5 = $[11]), useLayoutEffect(t4, t5);
  let t6;
  return $[12] !== children || $[13] !== style ? (t6 = /* @__PURE__ */ jsx(Root$1, { style, children }), $[12] = children, $[13] = style, $[14] = t6) : t6 = $[14], t6;
}, itemKey = "presentation/panels", getStoredItem = () => JSON.parse(localStorage.getItem(itemKey) || "{}"), setStoredItem = (data) => {
  localStorage.setItem(itemKey, JSON.stringify(data));
}, getKeyForPanels = (panels) => panels.map((panel) => [panel.id, panel.order].join(":")).join(",");
function usePanelsStorage() {
  const $ = c(1);
  let t0;
  const get = _temp2$3, set = _temp3$2;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const setDebounced = debounce(set, 100);
    t1 = {
      get,
      set,
      setDebounced
    }, $[0] = t1;
  } else
    t1 = $[0];
  return t0 = t1, t0;
}
function _temp3$2(panels_0, widths) {
  const stored_0 = getStoredItem(), key_0 = getKeyForPanels(panels_0), data = {
    ...stored_0,
    [key_0]: widths
  };
  setStoredItem(data);
}
function _temp2$3(panels) {
  const stored = getStoredItem(), key = getKeyForPanels(panels);
  return Array.isArray(stored[key]) && stored[key].some(_temp$6) ? void 0 : stored[key];
}
function _temp$6(val) {
  return val === null;
}
function getNextWidth(panel, nextWidth, containerWidth) {
  const {
    maxWidth: maxWidthPx,
    minWidth: minWidthPx
  } = panel, maxWidth = maxWidthPx == null ? 100 : maxWidthPx / containerWidth * 100, minWidth = minWidthPx / containerWidth * 100;
  return Math.min(maxWidth, Math.max(minWidth, nextWidth));
}
function getNextWidths(delta, containerWidth, panelBefore, panelAfter, panelsState, initialDragState) {
  const {
    panels,
    widths: prevWidths
  } = panelsState, {
    widths: initialWidths
  } = initialDragState, widths = initialWidths || prevWidths, nextWidths = [...widths];
  {
    const pivotPanel2 = delta < 0 ? panelAfter : panelBefore, index2 = panels.findIndex((panel) => panel.id === pivotPanel2.id), width = widths[index2], nextWidth = getNextWidth(pivotPanel2, width + Math.abs(delta), containerWidth);
    if (width === nextWidth)
      return widths;
    delta = delta < 0 ? width - nextWidth : nextWidth - width;
  }
  let deltaApplied = 0, pivotPanel = delta < 0 ? panelBefore : panelAfter, index = panels.findIndex((panel) => panel.id === pivotPanel.id);
  for (; ; ) {
    const panel = panels[index], width = widths[index], deltaRemaining = Math.abs(delta) - Math.abs(deltaApplied), nextWidth = getNextWidth(panel, width - deltaRemaining, containerWidth);
    if (width !== nextWidth && (deltaApplied += width - nextWidth, nextWidths[index] = nextWidth, deltaApplied.toPrecision(10).localeCompare(Math.abs(delta).toPrecision(10), void 0, {
      numeric: !0
    }) >= 0))
      break;
    if (delta < 0) {
      if (--index < 0)
        break;
    } else if (++index >= panels.length)
      break;
  }
  return deltaApplied === 0 ? widths : (pivotPanel = delta < 0 ? panelAfter : panelBefore, index = panels.findIndex((panel) => panel.id === pivotPanel.id), nextWidths[index] = widths[index] + deltaApplied, nextWidths);
}
function getPanelWidth(panels, id, widths) {
  if (panels.length === 1) return "100";
  const index = panels.findIndex((panel) => panel.id === id), width = widths[index];
  return width == null ? "0" : width.toPrecision(10);
}
function getOffset(event, handleElement, initialOffset = 0, initialHandleElementRect = null) {
  const pointerOffset = event.clientX, elementOffset = (initialHandleElementRect || handleElement.getBoundingClientRect()).left;
  return pointerOffset - elementOffset - initialOffset;
}
function isPanel(element) {
  return element.type === "panel";
}
function isResizer(element) {
  return element.type === "resizer";
}
function getSortedElements(elements) {
  return Array.from(elements.values()).sort(({
    order: a
  }, {
    order: b
  }) => a == null && b == null ? 0 : a == null ? -1 : b == null ? 1 : a - b);
}
function validateWidths(panels, widthsToValidate, containerWidth) {
  const total = widthsToValidate.reduce((total2, width) => total2 + width, 0), widths = [...widthsToValidate].map((width) => width / total * 100);
  let remainingWidth = 0;
  for (let index = 0; index < panels.length; index++) {
    const panel = panels[index], width = widths[index], nextWidth = getNextWidth(panel, width, containerWidth);
    width != nextWidth && (remainingWidth += width - nextWidth, widths[index] = nextWidth);
  }
  if (remainingWidth.toFixed(3) !== "0.000")
    for (let index = 0; index < panels.length; index++) {
      const panel = panels[index];
      let {
        maxWidth,
        minWidth
      } = panel;
      minWidth = minWidth / containerWidth * 100, maxWidth != null && (maxWidth = maxWidth / containerWidth * 100);
      const width = Math.min(
        // eslint-disable-next-line no-negated-condition
        maxWidth ?? 100,
        Math.max(minWidth, widths[index] + remainingWidth)
      );
      if (width !== widths[index] && (remainingWidth -= width - widths[index], widths[index] = width, Math.abs(remainingWidth).toFixed(3) === "0.000"))
        break;
    }
  return widths;
}
function getDefaultWidths(panels) {
  let panelsWithoutWidth = panels.length, remainingWidthTotal = 100;
  const widthsWithNulls = panels.map((panel) => panel.defaultSize ? (remainingWidthTotal -= panel.defaultSize, panelsWithoutWidth -= 1, panel.defaultSize) : null), defaultWidth = remainingWidthTotal / panelsWithoutWidth;
  return widthsWithNulls.map((width) => width === null ? defaultWidth : width);
}
const PanelsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  overflow: hidden;
  width: 100%;
`, Panels = function(t0) {
  const $ = c(46), {
    children
  } = t0, panelsEl = useRef(null);
  let t1;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ new Map(), $[0] = t1) : t1 = $[0];
  const [elements, setElements] = useState(t1);
  let t2, t3;
  $[1] !== elements ? (t3 = getSortedElements(elements).filter(isPanel), $[1] = elements, $[2] = t3) : t3 = $[2], t2 = t3;
  const panels = t2;
  let t4;
  $[3] === Symbol.for("react.memo_cache_sentinel") ? (t4 = [], $[3] = t4) : t4 = $[3];
  const [widths, setWidths] = useState(t4), [activeResizer, setActiveResizer] = useState(null);
  let t5;
  $[4] !== elements || $[5] !== panels || $[6] !== widths ? (t5 = {
    elements,
    panels,
    widths
  }, $[4] = elements, $[5] = panels, $[6] = widths, $[7] = t5) : t5 = $[7];
  const panelsRef = useRef(t5);
  let t6;
  $[8] !== activeResizer || $[9] !== panels || $[10] !== widths ? (t6 = (id) => ({
    flexGrow: getPanelWidth(panels, id, widths),
    pointerEvents: activeResizer === null ? void 0 : "none"
  }), $[8] = activeResizer, $[9] = panels, $[10] = widths, $[11] = t6) : t6 = $[11];
  const getPanelStyle = t6;
  let t7;
  $[12] === Symbol.for("react.memo_cache_sentinel") ? (t7 = (id_0, data) => {
    setElements((prev) => {
      if (prev.has(id_0))
        return prev;
      const next = new Map(prev);
      return next.set(id_0, data), next;
    });
  }, $[12] = t7) : t7 = $[12];
  const registerElement = t7;
  let t8;
  $[13] === Symbol.for("react.memo_cache_sentinel") ? (t8 = (id_1) => {
    setElements((prev_0) => {
      if (!prev_0.has(id_1))
        return prev_0;
      const next_0 = new Map(prev_0);
      return next_0.delete(id_1), next_0;
    });
  }, $[13] = t8) : t8 = $[13];
  const unregisterElement = t8;
  let t9;
  $[14] === Symbol.for("react.memo_cache_sentinel") ? (t9 = {
    containerWidth: window.innerWidth,
    dragOffset: 0,
    panelAfter: null,
    panelBefore: null,
    resizerIndex: -1,
    resizerRect: null,
    startX: 0,
    widths: []
  }, $[14] = t9) : t9 = $[14];
  const dragRef = useRef(t9);
  let t10;
  $[15] !== elements ? (t10 = (id_2, event) => {
    const elementsArr = getSortedElements(elements), index = elementsArr.findIndex((el) => el.id === id_2), resizer = elements.get(id_2);
    if (!resizer || !isResizer(resizer))
      return;
    const resizeElement = resizer.el.current;
    resizeElement && (dragRef.current = {
      resizerIndex: index,
      panelBefore: elementsArr.reduce((acc, el_0, i) => isPanel(el_0) && i < index ? el_0 : acc, null),
      panelAfter: elementsArr.reduce((acc_0, el_1, i_0) => acc_0 === null && isPanel(el_1) && i_0 > index ? el_1 : acc_0, null),
      containerWidth: window.innerWidth,
      startX: event.pageX,
      dragOffset: getOffset(event, resizeElement),
      resizerRect: resizeElement.getBoundingClientRect(),
      widths: panelsRef.current.widths
    }, setActiveResizer(id_2));
  }, $[15] = elements, $[16] = t10) : t10 = $[16];
  const startDragging = t10;
  let t11;
  $[17] === Symbol.for("react.memo_cache_sentinel") ? (t11 = () => {
    setActiveResizer(null);
  }, $[17] = t11) : t11 = $[17];
  const stopDragging = t11;
  let t12;
  $[18] !== elements ? (t12 = (id_3, event_0) => {
    event_0.preventDefault(), event_0.stopPropagation();
    const {
      containerWidth,
      dragOffset,
      panelBefore,
      panelAfter,
      resizerRect
    } = dragRef.current;
    if (panelBefore == null || panelAfter == null)
      return;
    const resizer_0 = elements.get(id_3);
    if (!resizer_0 || !isResizer(resizer_0))
      return;
    const resizeElement_0 = resizer_0.el.current;
    if (!resizeElement_0)
      return;
    const offset = getOffset(event_0, resizeElement_0, dragOffset, resizerRect);
    if (offset === 0)
      return;
    const {
      widths: prevWidths
    } = panelsRef.current, rect = panelsEl.current.getBoundingClientRect(), delta = offset / rect.width * 100, nextWidths = getNextWidths(delta, containerWidth, panelBefore, panelAfter, panelsRef.current, dragRef.current);
    prevWidths.some((prevWidth, i_1) => prevWidth !== nextWidths[i_1]) && setWidths(nextWidths);
  }, $[18] = elements, $[19] = t12) : t12 = $[19];
  const drag = t12;
  let t13, t14;
  $[20] !== elements || $[21] !== panels || $[22] !== widths ? (t13 = () => {
    panelsRef.current.elements = elements, panelsRef.current.panels = panels, panelsRef.current.widths = widths;
  }, t14 = [elements, panels, widths], $[20] = elements, $[21] = panels, $[22] = widths, $[23] = t13, $[24] = t14) : (t13 = $[23], t14 = $[24]), useLayoutEffect(t13, t14);
  const storage = usePanelsStorage();
  let t15, t16;
  $[25] !== panels || $[26] !== storage ? (t15 = () => {
    const {
      widths: widths_0
    } = panelsRef.current;
    if (widths_0.length === panels.length)
      return;
    const storedWidths = storage.get(panels);
    if (storedWidths) {
      const validatedStoredWidths = validateWidths(panels, storedWidths, window.innerWidth);
      setWidths(validatedStoredWidths);
      return;
    }
    const defaultWidths = getDefaultWidths(panels);
    setWidths(defaultWidths);
  }, t16 = [storage, panels], $[25] = panels, $[26] = storage, $[27] = t15, $[28] = t16) : (t15 = $[27], t16 = $[28]), useLayoutEffect(t15, t16);
  let t17, t18;
  $[29] !== panels || $[30] !== storage || $[31] !== widths ? (t17 = () => {
    widths.length && storage.setDebounced(panels, widths);
  }, t18 = [storage, panels, widths], $[29] = panels, $[30] = storage, $[31] = widths, $[32] = t17, $[33] = t18) : (t17 = $[32], t18 = $[33]), useEffect(t17, t18);
  let t19, t20;
  $[34] === Symbol.for("react.memo_cache_sentinel") ? (t19 = () => {
    const resizeObserver = new ResizeObserver(() => {
      const {
        panels: panels_0,
        widths: prevWidths_0
      } = panelsRef.current, nextWidths_0 = validateWidths(panels_0, prevWidths_0, window.innerWidth);
      prevWidths_0.some((prevWidth_0, i_2) => prevWidth_0 !== nextWidths_0[i_2]) && setWidths(nextWidths_0);
    });
    return resizeObserver.observe(panelsEl.current), () => {
      resizeObserver.disconnect();
    };
  }, t20 = [], $[34] = t19, $[35] = t20) : (t19 = $[34], t20 = $[35]), useLayoutEffect(t19, t20);
  let t21, t22;
  $[36] !== activeResizer || $[37] !== drag || $[38] !== getPanelStyle || $[39] !== startDragging ? (t22 = {
    activeResizer,
    drag,
    getPanelStyle,
    registerElement,
    startDragging,
    stopDragging,
    unregisterElement
  }, $[36] = activeResizer, $[37] = drag, $[38] = getPanelStyle, $[39] = startDragging, $[40] = t22) : t22 = $[40], t21 = t22;
  const context = t21;
  let t23;
  $[41] !== children ? (t23 = /* @__PURE__ */ jsx(PanelsWrapper, { ref: panelsEl, children }), $[41] = children, $[42] = t23) : t23 = $[42];
  let t24;
  return $[43] !== context || $[44] !== t23 ? (t24 = /* @__PURE__ */ jsx(PresentationPanelsContext.Provider, { value: context, children: t23 }), $[43] = context, $[44] = t23, $[45] = t24) : t24 = $[45], t24;
};
function ErrorCard(props) {
  const $ = c(37);
  let children, message, onContinueAnyway, onRetry, restProps;
  $[0] !== props ? ({
    children,
    message,
    onRetry,
    onContinueAnyway,
    ...restProps
  } = props, $[0] = props, $[1] = children, $[2] = message, $[3] = onContinueAnyway, $[4] = onRetry, $[5] = restProps) : (children = $[1], message = $[2], onContinueAnyway = $[3], onRetry = $[4], restProps = $[5]);
  const {
    t
  } = useTranslation(presentationLocaleNamespace);
  let t0;
  $[6] !== t ? (t0 = t("error-card.retry-button.text"), $[6] = t, $[7] = t0) : t0 = $[7];
  let t1;
  $[8] !== onRetry || $[9] !== t0 ? (t1 = /* @__PURE__ */ jsx(Button, { mode: "ghost", onClick: onRetry, text: t0 }), $[8] = onRetry, $[9] = t0, $[10] = t1) : t1 = $[10];
  const retryButton = t1;
  let t2;
  $[11] !== t ? (t2 = t("error-card.continue-button.text"), $[11] = t, $[12] = t2) : t2 = $[12];
  let t3;
  $[13] !== onContinueAnyway || $[14] !== t2 ? (t3 = /* @__PURE__ */ jsx(Button, { mode: "ghost", tone: "critical", onClick: onContinueAnyway, text: t2 }), $[13] = onContinueAnyway, $[14] = t2, $[15] = t3) : t3 = $[15];
  const continueAnywayButton = t3;
  let t4;
  $[16] !== t ? (t4 = t("error-card.title"), $[16] = t, $[17] = t4) : t4 = $[17];
  let t5;
  $[18] !== t4 ? (t5 = /* @__PURE__ */ jsx(Text, { size: 1, weight: "semibold", children: t4 }), $[18] = t4, $[19] = t5) : t5 = $[19];
  let t6;
  $[20] !== message ? (t6 = /* @__PURE__ */ jsx(Text, { muted: !0, size: 1, children: message }), $[20] = message, $[21] = t6) : t6 = $[21];
  let t7;
  $[22] !== t5 || $[23] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
    t5,
    t6
  ] }), $[22] = t5, $[23] = t6, $[24] = t7) : t7 = $[24];
  let t8;
  $[25] !== continueAnywayButton || $[26] !== onContinueAnyway || $[27] !== onRetry || $[28] !== retryButton ? (t8 = onRetry && onContinueAnyway ? /* @__PURE__ */ jsxs(Inline, { space: 2, children: [
    retryButton,
    continueAnywayButton
  ] }) : onRetry ? /* @__PURE__ */ jsx(Box, { children: retryButton }) : onContinueAnyway ? /* @__PURE__ */ jsx(Box, { children: continueAnywayButton }) : null, $[25] = continueAnywayButton, $[26] = onContinueAnyway, $[27] = onRetry, $[28] = retryButton, $[29] = t8) : t8 = $[29];
  let t9;
  $[30] !== children || $[31] !== t7 || $[32] !== t8 ? (t9 = /* @__PURE__ */ jsx(Flex, { align: "center", height: "fill", justify: "center", children: /* @__PURE__ */ jsx(Container$1, { padding: 4, sizing: "border", width: 0, children: /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    t7,
    children,
    t8
  ] }) }) }), $[30] = children, $[31] = t7, $[32] = t8, $[33] = t9) : t9 = $[33];
  let t10;
  return $[34] !== restProps || $[35] !== t9 ? (t10 = /* @__PURE__ */ jsx(Card, { height: "fill", ...restProps, children: t9 }), $[34] = restProps, $[35] = t9, $[36] = t10) : t10 = $[36], t10;
}
function encodeQueryString(params = {}) {
  const parts = Object.entries(params).map(([key, value]) => `${key}=${value}`).join("&");
  return parts.length ? `?${parts}` : "";
}
function resolveQueryStringFromParams(nextParams) {
  const allowed = ["comment", "inspect", "instruction", "pathKey", "rev", "since", "template", "view"], safeNextParams = Object.entries(nextParams).filter(([key]) => allowed.includes(key)).reduce((obj, [key, value]) => value == null ? obj : {
    ...obj,
    [key]: value
  }, {});
  return encodeQueryString(safeNextParams);
}
const BackLink = forwardRef(function(props, ref) {
  const $ = c(11);
  let restProps, searchParams;
  $[0] !== props ? ({
    searchParams,
    ...restProps
  } = props, $[0] = props, $[1] = restProps, $[2] = searchParams) : (restProps = $[1], searchParams = $[2]);
  let t0;
  $[3] !== searchParams ? (t0 = Object.entries(searchParams), $[3] = searchParams, $[4] = t0) : t0 = $[4];
  let t1;
  $[5] !== t0 ? (t1 = {
    type: void 0,
    _searchParams: t0
  }, $[5] = t0, $[6] = t1) : t1 = $[6];
  let t2;
  return $[7] !== ref || $[8] !== restProps || $[9] !== t1 ? (t2 = /* @__PURE__ */ jsx(StateLink, { ...restProps, ref, state: t1, title: void 0 }), $[7] = ref, $[8] = restProps, $[9] = t1, $[10] = t2) : t2 = $[10], t2;
}), ReferenceChildLink = forwardRef(function(props, ref) {
  const $ = c(15);
  let documentId, documentType, restProps, searchParams;
  if ($[0] !== props) {
    const {
      documentId: t02,
      documentType: t12,
      parentRefPath,
      template,
      searchParams: t22,
      ...t3
    } = props;
    documentId = t02, documentType = t12, searchParams = t22, restProps = t3, $[0] = props, $[1] = documentId, $[2] = documentType, $[3] = restProps, $[4] = searchParams;
  } else
    documentId = $[1], documentType = $[2], restProps = $[3], searchParams = $[4];
  let t0;
  $[5] !== searchParams ? (t0 = Object.entries(searchParams), $[5] = searchParams, $[6] = t0) : t0 = $[6];
  let t1;
  $[7] !== documentId || $[8] !== documentType || $[9] !== t0 ? (t1 = {
    id: documentId,
    type: documentType,
    _searchParams: t0
  }, $[7] = documentId, $[8] = documentType, $[9] = t0, $[10] = t1) : t1 = $[10];
  let t2;
  return $[11] !== ref || $[12] !== restProps || $[13] !== t1 ? (t2 = /* @__PURE__ */ jsx(StateLink, { ...restProps, ref, state: t1, title: void 0 }), $[11] = ref, $[12] = restProps, $[13] = t1, $[14] = t2) : t2 = $[14], t2;
});
function PresentationPaneRouterProvider(props) {
  const $ = c(26), {
    children,
    onStructureParams,
    structureParams,
    searchParams,
    refs
  } = props, {
    state: routerState,
    resolvePathFromState
  } = useRouter();
  let t0;
  $[0] !== routerState._searchParams ? (t0 = Object.fromEntries(routerState._searchParams || []), $[0] = routerState._searchParams, $[1] = t0) : t0 = $[1];
  const routerSearchParams = useUnique(t0);
  let t1;
  $[2] !== resolvePathFromState || $[3] !== routerSearchParams || $[4] !== routerState ? (t1 = (nextParams) => {
    const path = resolvePathFromState(routerState), qs = resolveQueryStringFromParams({
      ...routerSearchParams,
      ...nextParams
    });
    return `${path}${qs}`;
  }, $[2] = resolvePathFromState, $[3] = routerSearchParams, $[4] = routerState, $[5] = t1) : t1 = $[5];
  const createPathWithParams = t1;
  let t2, t3;
  $[6] === Symbol.for("react.memo_cache_sentinel") ? (t3 = {}, $[6] = t3) : t3 = $[6];
  const t4 = structureParams;
  let t5;
  $[7] === Symbol.for("react.memo_cache_sentinel") ? (t5 = [], $[7] = t5) : t5 = $[7];
  let t6;
  $[8] !== refs || $[9] !== searchParams ? (t6 = (childLinkProps) => {
    const {
      childId,
      ...restProps
    } = childLinkProps, ref = refs?.find((r) => r._id === childId || getPublishedId(r._id) === childId);
    return ref ? /* @__PURE__ */ jsx(StateLink, { ...restProps, state: {
      id: childId,
      type: ref._type,
      _searchParams: Object.entries(searchParams)
    } }) : /* @__PURE__ */ jsx("div", { ...restProps });
  }, $[8] = refs, $[9] = searchParams, $[10] = t6) : t6 = $[10];
  let t7, t8;
  $[11] !== searchParams ? (t7 = (backLinkProps) => /* @__PURE__ */ jsx(BackLink, { ...backLinkProps, searchParams }), t8 = (childLinkProps_0) => /* @__PURE__ */ jsx(ReferenceChildLink, { ...childLinkProps_0, searchParams }), $[11] = searchParams, $[12] = t7, $[13] = t8) : (t7 = $[12], t8 = $[13]);
  let t9;
  $[14] !== onStructureParams ? (t9 = (nextParams_0) => {
    onStructureParams({
      ...nextParams_0,
      inspect: nextParams_0.inspect ?? void 0
    });
  }, $[14] = onStructureParams, $[15] = t9) : t9 = $[15];
  let t10;
  $[16] !== createPathWithParams || $[17] !== t4 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8 || $[21] !== t9 ? (t10 = {
    index: 0,
    groupIndex: 0,
    siblingIndex: 0,
    payload: t3,
    params: t4,
    hasGroupSiblings: !1,
    groupLength: 1,
    routerPanesState: t5,
    ChildLink: t6,
    BackLink: t7,
    ReferenceChildLink: t8,
    ParameterizedLink: _temp$5,
    closeCurrentAndAfter: _temp2$2,
    handleEditReference: _temp3$1,
    replaceCurrent: _temp4,
    closeCurrent: _temp5,
    duplicateCurrent: _temp6,
    setView: _temp7,
    setParams: t9,
    setPayload: _temp8,
    navigateIntent: _temp9,
    createPathWithParams
  }, $[16] = createPathWithParams, $[17] = t4, $[18] = t6, $[19] = t7, $[20] = t8, $[21] = t9, $[22] = t10) : t10 = $[22], t2 = t10;
  const context = t2;
  let t11;
  return $[23] !== children || $[24] !== context ? (t11 = /* @__PURE__ */ jsx(PaneRouterContext.Provider, { value: context, children }), $[23] = children, $[24] = context, $[25] = t11) : t11 = $[25], t11;
}
function _temp9(intentName, intentParams, options_0) {
  console.warn("navigateIntent", intentName, intentParams, options_0);
}
function _temp8(payload) {
  console.warn("setPayload", payload);
}
function _temp7(viewId) {
  console.warn("setView", viewId);
}
function _temp6(pane_0) {
  console.warn("duplicateCurrent", pane_0);
}
function _temp5() {
  console.warn("closeCurrent");
}
function _temp4(pane) {
  console.warn("replaceCurrent", pane);
}
function _temp3$1(options) {
  console.warn("handleEditReference", options);
}
function _temp2$2() {
  console.warn("closeCurrentAndAfter");
}
function _temp$5() {
  throw new Error("ParameterizedLink not implemented");
}
const RootLayout = styled(PaneLayout)`
  height: 100%;
`, Root = styled(Flex)`
  & > div {
    min-width: none !important;
    max-width: none !important;
  }
`, WrappedCode$1 = styled(Code)`
  white-space: pre-wrap;
`;
function DocumentListPane(props) {
  const $ = c(33), {
    mainDocumentState,
    onStructureParams,
    searchParams,
    refs
  } = props, {
    t
  } = useTranslation(presentationLocaleNamespace), {
    devMode
  } = usePresentationTool();
  let t0, t1;
  if ($[0] !== mainDocumentState?.document?._id || $[1] !== refs) {
    let t22;
    $[3] !== mainDocumentState?.document?._id ? (t22 = (r) => getPublishedId(r._id) !== mainDocumentState?.document?._id, $[3] = mainDocumentState?.document?._id, $[4] = t22) : t22 = $[4], t1 = refs.filter(t22).map(_temp$4), $[0] = mainDocumentState?.document?._id, $[1] = refs, $[2] = t1;
  } else
    t1 = $[2];
  t0 = t1;
  const ids = t0;
  let t2, t3;
  $[5] !== ids ? (t3 = {
    filter: "_id in $ids",
    params: {
      ids
    }
  }, $[5] = ids, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== t ? (t4 = t("document-list-pane.document-list.title"), $[7] = t, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== t3 || $[10] !== t4 ? (t5 = {
    id: "$root",
    options: t3,
    schemaTypeName: "",
    title: t4,
    type: "documentList"
  }, $[9] = t3, $[10] = t4, $[11] = t5) : t5 = $[11], t2 = t5;
  const pane = t2, [errorParams, setErrorParams] = useState(null);
  let t6;
  $[12] === Symbol.for("react.memo_cache_sentinel") ? (t6 = () => setErrorParams(null), $[12] = t6) : t6 = $[12];
  const handleRetry = t6, [structureParams] = useState(_temp2$1);
  let t7;
  $[13] === Symbol.for("react.memo_cache_sentinel") ? (t7 = () => setErrorParams(null), $[13] = t7) : t7 = $[13];
  let t8;
  if ($[14] !== refs ? (t8 = [refs], $[14] = refs, $[15] = t8) : t8 = $[15], useEffect(t7, t8), errorParams) {
    let t92;
    $[16] !== t ? (t92 = t("document-list-pane.error.text"), $[16] = t, $[17] = t92) : t92 = $[17];
    let t102;
    $[18] !== devMode || $[19] !== errorParams || $[20] !== t ? (t102 = devMode && /* @__PURE__ */ jsx(Card, { overflow: "auto", padding: 3, radius: 2, tone: "critical", children: /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
      /* @__PURE__ */ jsx(Label, { muted: !0, size: 0, children: t("presentation-error.label") }),
      /* @__PURE__ */ jsx(WrappedCode$1, { size: 1, children: errorParams.error.message })
    ] }) }), $[18] = devMode, $[19] = errorParams, $[20] = t, $[21] = t102) : t102 = $[21];
    let t11;
    return $[22] !== t102 || $[23] !== t92 ? (t11 = /* @__PURE__ */ jsx(ErrorCard, { flex: 1, message: t92, onRetry: handleRetry, children: t102 }), $[22] = t102, $[23] = t92, $[24] = t11) : t11 = $[24], t11;
  }
  let t9;
  $[25] !== pane ? (t9 = /* @__PURE__ */ jsx(Root, { direction: "column", flex: 1, children: /* @__PURE__ */ jsx(DocumentListPane$1, { index: 0, itemId: "$root", pane, paneKey: "$root" }) }), $[25] = pane, $[26] = t9) : t9 = $[26];
  let t10;
  return $[27] !== onStructureParams || $[28] !== refs || $[29] !== searchParams || $[30] !== structureParams || $[31] !== t9 ? (t10 = /* @__PURE__ */ jsx(ErrorBoundary, { onCatch: setErrorParams, children: /* @__PURE__ */ jsx(RootLayout, { children: /* @__PURE__ */ jsx(StructureToolProvider, { children: /* @__PURE__ */ jsx(PresentationPaneRouterProvider, { onStructureParams, structureParams, searchParams, refs, children: t9 }) }) }) }), $[27] = onStructureParams, $[28] = refs, $[29] = searchParams, $[30] = structureParams, $[31] = t9, $[32] = t10) : t10 = $[32], t10;
}
function _temp2$1() {
  return {};
}
function _temp$4(r_0) {
  return getPublishedId(r_0._id);
}
const WrappedCode = styled(Code)`
  white-space: pre-wrap;
`;
function DocumentPane(props) {
  const $ = c(35), {
    documentId,
    documentType,
    onFocusPath,
    onStructureParams,
    searchParams,
    structureParams
  } = props, {
    template,
    templateParams
  } = structureParams, {
    t
  } = useTranslation(presentationLocaleNamespace), {
    devMode
  } = usePresentationTool();
  let t0, t1;
  $[0] !== templateParams ? (t1 = decodeJsonParams(templateParams), $[0] = templateParams, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== documentId || $[3] !== documentType || $[4] !== t1 || $[5] !== template ? (t2 = {
    id: documentId,
    type: documentType,
    template,
    templateParameters: t1
  }, $[2] = documentId, $[3] = documentType, $[4] = t1, $[5] = template, $[6] = t2) : t2 = $[6];
  let t3;
  $[7] !== documentId || $[8] !== t2 ? (t3 = {
    id: documentId,
    options: t2,
    title: "",
    type: "document"
  }, $[7] = documentId, $[8] = t2, $[9] = t3) : t3 = $[9], t0 = t3;
  const paneDocumentNode = t0, [errorParams, setErrorParams] = useState(null);
  let t4;
  $[10] === Symbol.for("react.memo_cache_sentinel") ? (t4 = () => setErrorParams(null), $[10] = t4) : t4 = $[10];
  const handleRetry = t4;
  let t5;
  $[11] === Symbol.for("react.memo_cache_sentinel") ? (t5 = () => {
    setErrorParams(null);
  }, $[11] = t5) : t5 = $[11];
  let t6;
  if ($[12] !== documentId || $[13] !== documentType || $[14] !== structureParams ? (t6 = [documentId, documentType, structureParams], $[12] = documentId, $[13] = documentType, $[14] = structureParams, $[15] = t6) : t6 = $[15], useEffect(t5, t6), errorParams) {
    let t72;
    $[16] !== t ? (t72 = t("document-pane.error.text"), $[16] = t, $[17] = t72) : t72 = $[17];
    let t82;
    $[18] !== devMode || $[19] !== errorParams || $[20] !== t ? (t82 = devMode && /* @__PURE__ */ jsx(Card, { overflow: "auto", padding: 3, radius: 2, tone: "critical", children: /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
      /* @__PURE__ */ jsx(Label, { muted: !0, size: 0, children: t("presentation-error.label") }),
      /* @__PURE__ */ jsx(WrappedCode, { size: 1, children: errorParams.error.message })
    ] }) }), $[18] = devMode, $[19] = errorParams, $[20] = t, $[21] = t82) : t82 = $[21];
    let t92;
    return $[22] !== t72 || $[23] !== t82 ? (t92 = /* @__PURE__ */ jsx(ErrorCard, { flex: 1, message: t72, onRetry: handleRetry, children: t82 }), $[22] = t72, $[23] = t82, $[24] = t92) : t92 = $[24], t92;
  }
  let t7;
  $[25] === Symbol.for("react.memo_cache_sentinel") ? (t7 = {
    height: "100%"
  }, $[25] = t7) : t7 = $[25];
  let t8;
  $[26] === Symbol.for("react.memo_cache_sentinel") ? (t8 = /* @__PURE__ */ jsx(PresentationSpinner, {}), $[26] = t8) : t8 = $[26];
  let t9;
  $[27] !== onFocusPath || $[28] !== paneDocumentNode ? (t9 = /* @__PURE__ */ jsx(Suspense, { fallback: t8, children: /* @__PURE__ */ jsx(DocumentPane$1, { paneKey: "document", index: 1, itemId: "document", pane: paneDocumentNode, onFocusPath }) }), $[27] = onFocusPath, $[28] = paneDocumentNode, $[29] = t9) : t9 = $[29];
  let t10;
  return $[30] !== onStructureParams || $[31] !== searchParams || $[32] !== structureParams || $[33] !== t9 ? (t10 = /* @__PURE__ */ jsx(ErrorBoundary, { onCatch: setErrorParams, children: /* @__PURE__ */ jsx(PaneLayout, { style: t7, children: /* @__PURE__ */ jsx(PresentationPaneRouterProvider, { searchParams, onStructureParams, structureParams, children: t9 }) }) }), $[30] = onStructureParams, $[31] = searchParams, $[32] = structureParams, $[33] = t9, $[34] = t10) : t10 = $[34], t10;
}
function DocumentPanel(props) {
  const $ = c(7), {
    documentId,
    documentType,
    onFocusPath,
    onStructureParams,
    searchParams,
    structureParams
  } = props;
  let t0;
  return $[0] !== documentId || $[1] !== documentType || $[2] !== onFocusPath || $[3] !== onStructureParams || $[4] !== searchParams || $[5] !== structureParams ? (t0 = /* @__PURE__ */ jsx(StructureToolProvider, { children: /* @__PURE__ */ jsx(DocumentPane, { documentId, documentType, onFocusPath, onStructureParams, searchParams, structureParams }) }), $[0] = documentId, $[1] = documentType, $[2] = onFocusPath, $[3] = onStructureParams, $[4] = searchParams, $[5] = structureParams, $[6] = t0) : t0 = $[6], t0;
}
function usePreviewState(documentId, schemaType2) {
  const $ = c(6), documentPreviewStore = useDocumentPreviewStore();
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {}, $[0] = t0) : t0 = $[0];
  const [preview, setPreview] = useState(t0);
  let t1, t2;
  return $[1] !== documentId || $[2] !== documentPreviewStore || $[3] !== schemaType2 ? (t1 = () => {
    if (!schemaType2)
      return;
    const subscription = getPreviewStateObservable(documentPreviewStore, schemaType2, documentId, "").subscribe((state) => {
      setPreview(state);
    });
    return () => {
      subscription?.unsubscribe();
    };
  }, t2 = [documentPreviewStore, schemaType2, documentId], $[1] = documentId, $[2] = documentPreviewStore, $[3] = schemaType2, $[4] = t1, $[5] = t2) : (t1 = $[4], t2 = $[5]), useEffect(t1, t2), preview;
}
function ContentEditor(props) {
  const $ = c(39), {
    documentId,
    documentType,
    mainDocumentState,
    onFocusPath,
    onStructureParams,
    refs,
    searchParams,
    structureParams
  } = props, {
    t
  } = useTranslation(presentationLocaleNamespace), schema = useSchema();
  let t0;
  $[0] !== mainDocumentState?.document?._id || $[1] !== mainDocumentState?.document?._type || $[2] !== searchParams ? (t0 = (props_0) => /* @__PURE__ */ jsx(StateLink, { ...props_0, state: {
    id: mainDocumentState?.document?._id,
    type: mainDocumentState?.document?._type,
    _searchParams: Object.entries(searchParams)
  } }), $[0] = mainDocumentState?.document?._id, $[1] = mainDocumentState?.document?._type, $[2] = searchParams, $[3] = t0) : t0 = $[3];
  const MainDocumentLink = t0;
  let t1, t2;
  $[4] !== mainDocumentState?.document?._type || $[5] !== schema ? (t2 = schema.get(mainDocumentState?.document?._type || "shoe"), $[4] = mainDocumentState?.document?._type, $[5] = schema, $[6] = t2) : t2 = $[6], t1 = t2;
  const schemaType2 = t1, previewState = usePreviewState(mainDocumentState?.document?._id || "", schemaType2);
  let t3;
  bb0: {
    if (!mainDocumentState?.document) {
      t3 = null;
      break bb0;
    }
    const t42 = mainDocumentState.document;
    let t52;
    $[7] !== previewState.draft || $[8] !== previewState.published || $[9] !== t42 ? (t52 = getPreviewValueWithFallback({
      value: t42,
      published: previewState.published,
      draft: previewState.draft
    }), $[7] = previewState.draft, $[8] = previewState.published, $[9] = t42, $[10] = t52) : t52 = $[10];
    let t62;
    $[11] !== t ? (t62 = t("main-document.label"), $[11] = t, $[12] = t62) : t62 = $[12];
    let t7;
    $[13] !== t62 ? (t7 = /* @__PURE__ */ jsx(Card, { padding: 1, radius: 2, shadow: 1, children: /* @__PURE__ */ jsx(Text, { muted: !0, size: 0, weight: "medium", children: t62 }) }), $[13] = t62, $[14] = t7) : t7 = $[14];
    let t8;
    $[15] !== schemaType2 || $[16] !== t52 || $[17] !== t7 ? (t8 = /* @__PURE__ */ jsx(SanityDefaultPreview, { ...t52, schemaType: schemaType2, status: t7 }), $[15] = schemaType2, $[16] = t52, $[17] = t7, $[18] = t8) : t8 = $[18], t3 = t8;
  }
  const preview = t3;
  if (documentId && documentType) {
    let t42;
    return $[19] !== documentId || $[20] !== documentType || $[21] !== onFocusPath || $[22] !== onStructureParams || $[23] !== searchParams || $[24] !== structureParams ? (t42 = /* @__PURE__ */ jsx(DocumentPanel, { documentId, documentType, onFocusPath, onStructureParams, searchParams, structureParams }), $[19] = documentId, $[20] = documentType, $[21] = onFocusPath, $[22] = onStructureParams, $[23] = searchParams, $[24] = structureParams, $[25] = t42) : t42 = $[25], t42;
  }
  let t4;
  $[26] !== MainDocumentLink || $[27] !== mainDocumentState || $[28] !== preview || $[29] !== t ? (t4 = mainDocumentState && /* @__PURE__ */ jsx(Card, { padding: 3, tone: mainDocumentState.document ? "inherit" : "caution", children: mainDocumentState.document ? /* @__PURE__ */ jsx(PreviewCard, { __unstable_focusRing: !0, as: MainDocumentLink, "data-as": "a", radius: 2, sizing: "border", tone: "inherit", children: preview }) : /* @__PURE__ */ jsx(Card, { padding: 2, radius: 2, tone: "inherit", children: /* @__PURE__ */ jsxs(Flex, { gap: 3, children: [
    /* @__PURE__ */ jsx(Box, { flex: "none", children: /* @__PURE__ */ jsx(Text, { size: 1, children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }) }),
    /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(Text, { size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "main-document.missing.text", components: {
      Code: "code"
    }, values: {
      path: mainDocumentState.path
    } }) }) })
  ] }) }) }), $[26] = MainDocumentLink, $[27] = mainDocumentState, $[28] = preview, $[29] = t, $[30] = t4) : t4 = $[30];
  let t5;
  $[31] !== mainDocumentState || $[32] !== onStructureParams || $[33] !== refs || $[34] !== searchParams ? (t5 = /* @__PURE__ */ jsx(DocumentListPane, { mainDocumentState, onStructureParams, searchParams, refs }), $[31] = mainDocumentState, $[32] = onStructureParams, $[33] = refs, $[34] = searchParams, $[35] = t5) : t5 = $[35];
  let t6;
  return $[36] !== t4 || $[37] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Flex, { direction: "column", flex: 1, height: "fill", children: [
    t4,
    t5
  ] }), $[36] = t4, $[37] = t5, $[38] = t6) : t6 = $[38], t6;
}
function usePanelId(id) {
  const $ = c(2);
  let t0;
  $[0] !== id ? (t0 = () => id || v4(), $[0] = id, $[1] = t0) : t0 = $[1];
  const [panelId] = useState(t0);
  return panelId;
}
const Resizer = styled.div`
  position: relative;
`, ResizerInner = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: -5px;
  width: 9px;
  z-index: 10;
  cursor: ${({
  $disabled
}) => $disabled ? "auto" : "ew-resize"};

  /* Border */
  & > span:nth-child(1) {
    display: block;
    border-left: 1px solid var(--card-border-color);
    position: absolute;
    top: 0;
    left: 4px;
    bottom: 0;
    transition: opacity 200ms;
  }

  ${({
  $disabled
}) => !$disabled && `
    /* Hover effect */
    & > span:nth-child(2) {
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 9px;
      bottom: 0;
      background-color: var(--card-border-color);
      opacity: 0;
      transition: opacity 150ms;
    }

    @media (hover: hover) {
      &:hover > span:nth-child(2) {
        opacity: 0.2;
      }
    }
  `}
`, PanelResizer = function(t0) {
  const $ = c(27), {
    id: propId,
    order,
    disabled: t1
  } = t0, disabled = t1 === void 0 ? !1 : t1, el = useRef(null), context = useContext(PresentationPanelsContext);
  if (context === null)
    throw Error("Panel components must be rendered within a PanelGroup container");
  const id = usePanelId(propId), {
    activeResizer,
    drag,
    startDragging,
    stopDragging,
    registerElement,
    unregisterElement
  } = context, isDragging = activeResizer === id;
  if (context === null)
    throw Error("Panel components must be rendered within a PanelGroup container");
  let t2;
  $[0] !== id || $[1] !== startDragging ? (t2 = (event) => {
    startDragging(id, event.nativeEvent);
  }, $[0] = id, $[1] = startDragging, $[2] = t2) : t2 = $[2];
  const onMouseDown = t2;
  let t3;
  $[3] !== drag || $[4] !== id ? (t3 = (e) => {
    drag(id, e);
  }, $[3] = drag, $[4] = id, $[5] = t3) : t3 = $[5];
  const onDrag = t3;
  let t4;
  $[6] !== stopDragging ? (t4 = () => {
    el.current.blur(), stopDragging();
  }, $[6] = stopDragging, $[7] = t4) : t4 = $[7];
  const onDragStop = t4;
  let t5, t6;
  $[8] !== disabled || $[9] !== isDragging || $[10] !== onDrag || $[11] !== onDragStop ? (t5 = () => {
    if (!isDragging || disabled)
      return;
    const resetDocumentStyles = function() {
      const bodyStyle = document.body.style, documentStyle = document.documentElement.style, {
        cursor
      } = documentStyle, {
        userSelect
      } = bodyStyle;
      return documentStyle.cursor = "ew-resize", bodyStyle.userSelect = "none", () => {
        cursor ? documentStyle.cursor = cursor : documentStyle.removeProperty("cursor"), userSelect ? bodyStyle.userSelect = userSelect : bodyStyle.removeProperty("user-select");
      };
    }();
    return window.addEventListener("mousemove", onDrag), window.addEventListener("mouseup", onDragStop), window.addEventListener("contextmenu", onDragStop), () => {
      resetDocumentStyles(), window.removeEventListener("mousemove", onDrag), window.removeEventListener("mouseup", onDragStop), window.removeEventListener("contextmenu", onDragStop);
    };
  }, t6 = [disabled, isDragging, onDrag, onDragStop], $[8] = disabled, $[9] = isDragging, $[10] = onDrag, $[11] = onDragStop, $[12] = t5, $[13] = t6) : (t5 = $[12], t6 = $[13]), useEffect(t5, t6);
  let t7, t8;
  $[14] !== id || $[15] !== order || $[16] !== registerElement || $[17] !== unregisterElement ? (t7 = () => (registerElement(id, {
    id,
    order,
    type: "resizer",
    el
  }), () => {
    unregisterElement(id);
  }), t8 = [id, order, registerElement, unregisterElement], $[14] = id, $[15] = order, $[16] = registerElement, $[17] = unregisterElement, $[18] = t7, $[19] = t8) : (t7 = $[18], t8 = $[19]), useLayoutEffect(t7, t8);
  let t10, t9;
  $[20] === Symbol.for("react.memo_cache_sentinel") ? (t9 = /* @__PURE__ */ jsx("span", {}), t10 = /* @__PURE__ */ jsx("span", {}), $[20] = t10, $[21] = t9) : (t10 = $[20], t9 = $[21]);
  let t11;
  $[22] !== disabled ? (t11 = /* @__PURE__ */ jsxs(ResizerInner, { $disabled: disabled, children: [
    t9,
    t10
  ] }), $[22] = disabled, $[23] = t11) : t11 = $[23];
  let t12;
  return $[24] !== onMouseDown || $[25] !== t11 ? (t12 = /* @__PURE__ */ jsx(Resizer, { onMouseDown, ref: el, children: t11 }), $[24] = onMouseDown, $[25] = t11, $[26] = t12) : t12 = $[26], t12;
}, PresentationContentWrapper = (props) => {
  const $ = c(8), {
    documentId,
    setDisplayedDocument,
    getCommentIntent
  } = props;
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(PanelResizer, { order: 4 }), $[0] = t0) : t0 = $[0];
  let t1;
  $[1] !== getCommentIntent || $[2] !== props.children ? (t1 = /* @__PURE__ */ jsx(CommentsIntentProvider, { getIntent: getCommentIntent, children: props.children }), $[1] = getCommentIntent, $[2] = props.children, $[3] = t1) : t1 = $[3];
  let t2;
  return $[4] !== documentId || $[5] !== setDisplayedDocument || $[6] !== t1 ? (t2 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t0,
    /* @__PURE__ */ jsx(Panel, { id: "content", minWidth: 325, order: 5, children: /* @__PURE__ */ jsx(DisplayedDocumentBroadcasterProvider, { documentId, setDisplayedDocument, children: t1 }) })
  ] }), $[4] = documentId, $[5] = setDisplayedDocument, $[6] = t1, $[7] = t2) : t2 = $[7], t2;
}, PresentationContent = (props) => {
  const $ = c(14), {
    documentId,
    documentsOnPage,
    documentType,
    getCommentIntent,
    mainDocumentState,
    onFocusPath,
    onStructureParams,
    searchParams,
    setDisplayedDocument,
    structureParams
  } = props;
  let t0;
  $[0] !== documentId || $[1] !== documentType || $[2] !== documentsOnPage || $[3] !== mainDocumentState || $[4] !== onFocusPath || $[5] !== onStructureParams || $[6] !== searchParams || $[7] !== structureParams ? (t0 = /* @__PURE__ */ jsx(ContentEditor, { documentId, documentType, mainDocumentState, onFocusPath, onStructureParams, refs: documentsOnPage, searchParams, structureParams }), $[0] = documentId, $[1] = documentType, $[2] = documentsOnPage, $[3] = mainDocumentState, $[4] = onFocusPath, $[5] = onStructureParams, $[6] = searchParams, $[7] = structureParams, $[8] = t0) : t0 = $[8];
  let t1;
  return $[9] !== documentId || $[10] !== getCommentIntent || $[11] !== setDisplayedDocument || $[12] !== t0 ? (t1 = /* @__PURE__ */ jsx(PresentationContentWrapper, { documentId, getCommentIntent, setDisplayedDocument, children: t0 }), $[9] = documentId, $[10] = getCommentIntent, $[11] = setDisplayedDocument, $[12] = t0, $[13] = t1) : t1 = $[13], t1;
}, PresentationNavigateProvider = function(props) {
  const $ = c(5), {
    children,
    navigate: _navigate
  } = props;
  let t0;
  $[0] !== _navigate ? (t0 = (preview, t12) => {
    _navigate((t12 === void 0 ? void 0 : t12) || {}, preview ? {
      preview
    } : {});
  }, $[0] = _navigate, $[1] = t0) : t0 = $[1];
  const navigate = t0;
  let t1;
  return $[2] !== children || $[3] !== navigate ? (t1 = /* @__PURE__ */ jsx(PresentationNavigateContext.Provider, { value: navigate, children }), $[2] = children, $[3] = navigate, $[4] = t1) : t1 = $[4], t1;
};
function useLocalState(key, defaultValue) {
  const $ = c(9);
  let t0;
  $[0] !== defaultValue || $[1] !== key ? (t0 = () => JSON.parse(localStorage.getItem(key) ?? JSON.stringify(defaultValue)), $[0] = defaultValue, $[1] = key, $[2] = t0) : t0 = $[2];
  const [value, setValue] = useState(t0);
  let t1, t2;
  $[3] !== key || $[4] !== value ? (t1 = () => {
    localStorage.setItem(key, JSON.stringify(value));
  }, t2 = [key, value], $[3] = key, $[4] = value, $[5] = t1, $[6] = t2) : (t1 = $[5], t2 = $[6]), useEffect(t1, t2);
  let t3;
  return $[7] !== value ? (t3 = [value, setValue], $[7] = value, $[8] = t3) : t3 = $[8], t3;
}
function usePresentationNavigator(props) {
  const $ = c(11), {
    unstable_navigator
  } = props, navigatorProvided = !!unstable_navigator?.component, [_navigatorEnabled, setNavigatorEnabled] = useLocalState("presentation/navigator", navigatorProvided), navigatorEnabled = navigatorProvided ? _navigatorEnabled : !1;
  let t0;
  bb0: {
    if (!navigatorProvided) {
      t0 = void 0;
      break bb0;
    }
    let t12;
    $[0] !== setNavigatorEnabled ? (t12 = () => setNavigatorEnabled(_temp$3), $[0] = setNavigatorEnabled, $[1] = t12) : t12 = $[1], t0 = t12;
  }
  const toggleNavigator = t0;
  let t1;
  $[2] !== navigatorEnabled || $[3] !== unstable_navigator ? (t1 = function() {
    return /* @__PURE__ */ jsx(Fragment, { children: navigatorEnabled && /* @__PURE__ */ jsx(Navigator, { ...unstable_navigator }) });
  }, $[2] = navigatorEnabled, $[3] = unstable_navigator, $[4] = t1) : t1 = $[4];
  const Component = t1;
  let t2;
  $[5] !== navigatorEnabled || $[6] !== toggleNavigator ? (t2 = {
    navigatorEnabled,
    toggleNavigator
  }, $[5] = navigatorEnabled, $[6] = toggleNavigator, $[7] = t2) : t2 = $[7];
  let t3;
  return $[8] !== Component || $[9] !== t2 ? (t3 = [t2, Component], $[8] = Component, $[9] = t2, $[10] = t3) : t3 = $[10], t3;
}
function _temp$3(enabled) {
  return !enabled;
}
function NavigatorComponent(props) {
  const $ = c(11), {
    minWidth,
    maxWidth,
    component: NavigatorComponent2
  } = props, navigatorDisabled = minWidth != null && maxWidth != null && minWidth === maxWidth;
  let t0;
  $[0] !== NavigatorComponent2 ? (t0 = /* @__PURE__ */ jsx(NavigatorComponent2, {}), $[0] = NavigatorComponent2, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== maxWidth || $[3] !== minWidth || $[4] !== t0 ? (t1 = /* @__PURE__ */ jsx(Panel, { id: "navigator", minWidth, maxWidth, order: 1, children: t0 }), $[2] = maxWidth, $[3] = minWidth, $[4] = t0, $[5] = t1) : t1 = $[5];
  let t2;
  $[6] !== navigatorDisabled ? (t2 = /* @__PURE__ */ jsx(PanelResizer, { order: 2, disabled: navigatorDisabled }), $[6] = navigatorDisabled, $[7] = t2) : t2 = $[7];
  let t3;
  return $[8] !== t1 || $[9] !== t2 ? (t3 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t1,
    t2
  ] }), $[8] = t1, $[9] = t2, $[10] = t3) : t3 = $[10], t3;
}
const Navigator = memo(NavigatorComponent), PresentationParamsProvider = function(props) {
  const $ = c(3), {
    children,
    params
  } = props;
  let t0;
  t0 = params;
  const context = t0;
  let t1;
  return $[0] !== children || $[1] !== context ? (t1 = /* @__PURE__ */ jsx(PresentationParamsContext.Provider, { value: context, children }), $[0] = children, $[1] = context, $[2] = t1) : t1 = $[2], t1;
}, PresentationProvider = function(props) {
  const $ = c(10), {
    children,
    devMode,
    name,
    navigate,
    params,
    searchParams,
    structureParams
  } = props;
  let t0, t1;
  $[0] !== devMode || $[1] !== name || $[2] !== navigate || $[3] !== params || $[4] !== searchParams || $[5] !== structureParams ? (t1 = {
    devMode,
    name,
    navigate,
    params,
    searchParams,
    structureParams
  }, $[0] = devMode, $[1] = name, $[2] = navigate, $[3] = params, $[4] = searchParams, $[5] = structureParams, $[6] = t1) : t1 = $[6], t0 = t1;
  const context = t0;
  let t2;
  return $[7] !== children || $[8] !== context ? (t2 = /* @__PURE__ */ jsx(PresentationContext.Provider, { value: context, children }), $[7] = children, $[8] = context, $[9] = t2) : t2 = $[9], t2;
};
function encodeStudioPerspective(studioPerspective) {
  return Array.isArray(studioPerspective) ? studioPerspective.join(",") : studioPerspective;
}
const IFrameElement = motion.create(styled.iframe`
  box-shadow: 0 0 0 1px var(--card-border-color);
  border: 0;
  max-height: 100%;
  width: 100%;
  view-transition-class: presentation-tool-iframe;
`), IFrameOverlay = styled(Box)`
  position: absolute;
  inset: 0;
  background: transparent;
`, IFrame = forwardRef(function(props, ref) {
  const $ = c(16), {
    animate,
    initial,
    onLoad,
    preventClick,
    src,
    variants,
    style
  } = props, t0 = `presentation-tool-iframe-${useId().replace(/[^a-zA-Z0-9-_]/g, "_")}`;
  let t1;
  $[0] !== style || $[1] !== t0 ? (t1 = {
    ...style,
    viewTransitionName: t0
  }, $[0] = style, $[1] = t0, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== animate || $[4] !== initial || $[5] !== onLoad || $[6] !== ref || $[7] !== src || $[8] !== t1 || $[9] !== variants ? (t2 = /* @__PURE__ */ jsx(IFrameElement, { style: t1, animate, initial, onLoad, ref, src, variants }), $[3] = animate, $[4] = initial, $[5] = onLoad, $[6] = ref, $[7] = src, $[8] = t1, $[9] = variants, $[10] = t2) : t2 = $[10];
  let t3;
  $[11] !== preventClick ? (t3 = preventClick && /* @__PURE__ */ jsx(IFrameOverlay, {}), $[11] = preventClick, $[12] = t3) : t3 = $[12];
  let t4;
  return $[13] !== t2 || $[14] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t2,
    t3
  ] }), $[13] = t2, $[14] = t3, $[15] = t4) : t4 = $[15], t4;
});
function OpenPreviewButton(props) {
  const $ = c(16), {
    openPopup,
    previewLocationOrigin,
    previewLocationRoute
  } = props, {
    t
  } = useTranslation(presentationLocaleNamespace);
  let t0;
  $[0] !== openPopup ? (t0 = (event) => {
    event.preventDefault(), openPopup(event.currentTarget.href);
  }, $[0] = openPopup, $[1] = t0) : t0 = $[1];
  const handleOpenPopup = t0;
  let t1;
  $[2] !== t ? (t1 = t("share-url.menu-item.open.text"), $[2] = t, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] !== t1 ? (t2 = /* @__PURE__ */ jsx(Text, { size: 1, children: t1 }), $[4] = t1, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] === Symbol.for("react.memo_cache_sentinel") ? (t3 = ["bottom-start"], $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== t ? (t4 = t("share-url.menu-item.open.text"), $[7] = t, $[8] = t4) : t4 = $[8];
  const t5 = `${previewLocationOrigin}${previewLocationRoute}`;
  let t6;
  $[9] !== handleOpenPopup || $[10] !== t4 || $[11] !== t5 ? (t6 = /* @__PURE__ */ jsx(Button, { as: "a", "aria-label": t4, icon: LaunchIcon, mode: "bleed", href: t5, rel: "opener", target: "_blank", tooltipProps: null, onClick: handleOpenPopup }), $[9] = handleOpenPopup, $[10] = t4, $[11] = t5, $[12] = t6) : t6 = $[12];
  let t7;
  return $[13] !== t2 || $[14] !== t6 ? (t7 = /* @__PURE__ */ jsx(Tooltip, { animate: !0, content: t2, fallbackPlacements: t3, placement: "bottom", portal: !0, children: t6 }), $[13] = t2, $[14] = t6, $[15] = t7) : t7 = $[15], t7;
}
const PreviewLocationInput = function(props) {
  const $ = c(27), {
    fontSize: t0,
    onChange,
    origin,
    padding: t1,
    prefix,
    suffix,
    value
  } = props, fontSize = t0 === void 0 ? 1 : t0, padding = t1 === void 0 ? 3 : t1, {
    t
  } = useTranslation(presentationLocaleNamespace), {
    basePath: t2
  } = useActiveWorkspace()?.activeWorkspace || {}, basePath = t2 === void 0 ? "/" : t2, inputRef = useRef(null), [sessionValue, setSessionValue] = useState(void 0), [customValidity, setCustomValidity] = useState(void 0);
  let t3;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t3 = (event) => {
    setSessionValue(event.currentTarget.value);
  }, $[0] = t3) : t3 = $[0];
  const handleChange = t3;
  let t4;
  $[1] !== basePath || $[2] !== onChange || $[3] !== origin || $[4] !== sessionValue || $[5] !== t ? (t4 = (event_0) => {
    if (event_0.key === "Enter") {
      if (sessionValue === void 0)
        return;
      const absoluteValue = sessionValue.startsWith("/") || sessionValue === "" ? `${origin}${sessionValue}` : sessionValue;
      if (!absoluteValue.startsWith(`${origin}/`) && absoluteValue !== origin) {
        setCustomValidity(t("preview-location-input.error", {
          origin,
          context: "missing-origin"
        }));
        return;
      }
      if (!origin && (absoluteValue.startsWith(`${basePath}/`) || absoluteValue === basePath)) {
        setCustomValidity(t("preview-location-input.error", {
          basePath,
          context: "same-base-path"
        }));
        return;
      }
      const nextValue = absoluteValue === origin ? `${origin}/` : absoluteValue;
      setCustomValidity(void 0), setSessionValue(void 0), onChange(nextValue.slice(origin.length)), inputRef.current?.blur();
    }
    event_0.key === "Escape" && (setCustomValidity(void 0), setSessionValue(void 0));
  }, $[1] = basePath, $[2] = onChange, $[3] = origin, $[4] = sessionValue, $[5] = t, $[6] = t4) : t4 = $[6];
  const handleKeyDown = t4;
  let t5;
  $[7] === Symbol.for("react.memo_cache_sentinel") ? (t5 = () => {
    setCustomValidity(void 0), setSessionValue(void 0);
  }, $[7] = t5) : t5 = $[7];
  const handleBlur = t5;
  let t6;
  $[8] === Symbol.for("react.memo_cache_sentinel") ? (t6 = () => {
    setCustomValidity(void 0), setSessionValue(void 0);
  }, $[8] = t6) : t6 = $[8];
  let t7;
  $[9] !== origin || $[10] !== value ? (t7 = [origin, value], $[9] = origin, $[10] = value, $[11] = t7) : t7 = $[11], useEffect(t6, t7);
  let t8, t9;
  $[12] === Symbol.for("react.memo_cache_sentinel") ? (t9 = {
    icon: ResetIcon
  }, $[12] = t9) : t9 = $[12], t8 = t9;
  const t10 = customValidity ? t8 : void 0;
  let t11;
  $[13] !== origin || $[14] !== value ? (t11 = () => {
    setCustomValidity(void 0), setSessionValue(origin + value);
  }, $[13] = origin, $[14] = value, $[15] = t11) : t11 = $[15];
  let t12;
  $[16] === Symbol.for("react.memo_cache_sentinel") ? (t12 = {
    zIndex: 1
  }, $[16] = t12) : t12 = $[16];
  const t13 = sessionValue === void 0 ? `${origin}${value}` : sessionValue;
  let t14;
  return $[17] !== customValidity || $[18] !== fontSize || $[19] !== handleKeyDown || $[20] !== padding || $[21] !== prefix || $[22] !== suffix || $[23] !== t10 || $[24] !== t11 || $[25] !== t13 ? (t14 = /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(TextInput, { clearButton: t10, customValidity, fontSize, onBlur: handleBlur, onClear: t11, onChange: handleChange, onKeyDownCapture: handleKeyDown, padding, prefix, style: t12, radius: 2, ref: inputRef, space: padding, suffix, value: t13 }) }), $[17] = customValidity, $[18] = fontSize, $[19] = handleKeyDown, $[20] = padding, $[21] = prefix, $[22] = suffix, $[23] = t10, $[24] = t11, $[25] = t13, $[26] = t14) : t14 = $[26], t14;
}, QRCodeSVG = lazy(() => import("./QRCodeSVG.mjs")), QrCodeLogoSize = 24, QrCodeLogoPadding = 16, QrSize = 224, StyledSanityMonogram = styled(SanityMonogram)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: ${QrCodeLogoSize}px;
  width: ${QrCodeLogoSize}px;
`, MotionSpinner = motion.create(Spinner), MotionText = motion.create(Text), MotionMonogram = motion.create(StyledSanityMonogram), SharePreviewMenu = memo(function(props) {
  const {
    canToggleSharePreviewAccess,
    canUseSharedPreviewAccess,
    initialUrl,
    previewLocationRoute,
    perspective
  } = props, {
    t
  } = useTranslation(presentationLocaleNamespace), {
    push: pushToast
  } = useToast(), client = useClient({
    apiVersion: API_VERSION
  }), currentUser = useCurrentUser(), [loading, setLoading] = useState(!0), [enabling, setEnabling] = useState(!1), [disabling, setDisabling] = useState(!1), [secret, setSecret] = useState(null), busy = enabling || disabling || loading, url = useMemo(() => secret ? setSecretSearchParams(initialUrl, secret, previewLocationRoute, encodeStudioPerspective(perspective)) : null, [initialUrl, perspective, previewLocationRoute, secret]), [error, setError] = useState(null);
  if (error)
    throw error;
  const handleUnableToToggle = useCallback(() => {
    pushToast({
      closable: !0,
      status: "warning",
      title: t("share-preview-menu.error_toggle-sharing", {
        context: "toggle-sharing"
      })
    });
  }, [pushToast, t]), handleDisableSharing = useCallback(async () => {
    try {
      setDisabling(!0), await disablePreviewAccessSharing(client, "@sanity/presentation", typeof window > "u" ? "" : location.href, currentUser?.id), setSecret(null);
    } catch (error_0) {
      setError(error_0);
    } finally {
      setDisabling(!1);
    }
  }, [client, currentUser?.id]), handleEnableSharing = useCallback(async () => {
    try {
      setEnabling(!0);
      const previewUrlSecret = await enablePreviewAccessSharing(client, "@sanity/presentation", typeof window > "u" ? "" : location.href, currentUser?.id);
      setSecret(previewUrlSecret.secret);
    } catch (error_1) {
      setError(error_1);
    } finally {
      setEnabling(!1);
    }
  }, [client, currentUser?.id]), handleCopyUrl = useCallback(() => {
    try {
      if (!url)
        throw new Error("No URL to copy");
      navigator.clipboard.writeText(url.toString()), pushToast({
        closable: !0,
        status: "success",
        title: t("share-url.clipboard.status", {
          context: "success"
        })
      });
    } catch (error_2) {
      setError(error_2);
    }
  }, [pushToast, t, url]);
  return useEffect(() => {
    let controller = new AbortController(), usedTags = [];
    async function fetchShareSecret(lastLiveEventId, signal) {
      const {
        result,
        syncTags
      } = await client.fetch(fetchSharedAccessQuery, {}, {
        filterResponse: !1,
        lastLiveEventId,
        tag: "presentation.fetch-shared-access-secret"
      });
      Array.isArray(syncTags) && (usedTags = syncTags), signal.aborted || setSecret(result);
    }
    const subscription = client.live.events().subscribe({
      next: (event) => {
        event.type === "message" && (controller.abort(), controller = new AbortController(), event.tags.some((tag) => usedTags.includes(tag)) && fetchShareSecret(event.id, controller.signal));
      },
      error: setError
    });
    return fetchShareSecret(null, controller.signal).finally(() => setLoading(!1)), () => {
      subscription.unsubscribe(), controller.abort();
    };
  }, [client]), /* @__PURE__ */ jsx(MenuButton, { button: /* @__PURE__ */ jsx(Button, { "aria-label": t("preview-frame.share-button.aria-label"), icon: ShareIcon, mode: "bleed", tooltipProps: null }), id: "share-menu", menu: /* @__PURE__ */ jsx(Menu, { style: {
    maxWidth: 248
  }, padding: canUseSharedPreviewAccess ? void 0 : 0, children: canUseSharedPreviewAccess ? /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("label", { style: {
      cursor: "pointer"
    }, children: /* @__PURE__ */ jsxs(Grid, { columns: 2, rows: 2, gapX: 3, gapY: 1, style: {
      justifyContent: "center",
      alignItems: "center",
      gridTemplateColumns: "min-content 1fr",
      gridTemplateRows: "min-content"
    }, paddingTop: 3, paddingX: 3, children: [
      /* @__PURE__ */ jsx(Tooltip, { animate: !0, content: /* @__PURE__ */ jsx(Text, { size: 1, children: t("share-preview-menu.toggle-button.tooltip", {
        context: url ? "disable" : "enable"
      }) }), fallbackPlacements: ["bottom-start"], placement: "bottom", portal: !0, children: /* @__PURE__ */ jsx(Switch, { checked: enabling || url !== null && !disabling, readOnly: enabling || disabling, indeterminate: loading, onChange: canToggleSharePreviewAccess ? url ? handleDisableSharing : handleEnableSharing : handleUnableToToggle }) }),
      /* @__PURE__ */ jsx(Text, { size: 1, weight: "medium", children: t("share-preview-menu.toggle-button.label", {
        context: "first-line"
      }) }),
      /* @__PURE__ */ jsx("span", {}),
      /* @__PURE__ */ jsx(Text, { muted: !0, size: 1, children: t("share-preview-menu.toggle-button.label", {
        context: "second-line"
      }) })
    ] }) }),
    /* @__PURE__ */ jsx(Box, { padding: 3, paddingTop: 2, children: /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
      /* @__PURE__ */ jsx(Card, { tone: busy || !url ? "transparent" : void 0, style: {
        position: "relative",
        aspectRatio: "1 / 1",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }, children: /* @__PURE__ */ jsx(AnimatePresence, { children: busy ? /* @__PURE__ */ jsx(MotionSpinner, { muted: !0, initial: {
        opacity: 0
      }, animate: {
        opacity: 1
      }, exit: {
        opacity: 0
      } }) : url ? /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(Suspense, { fallback: /* @__PURE__ */ jsx(Spinner, {}), children: [
        /* @__PURE__ */ jsx(QRCodeSVG, { title: t("share-preview-menu.qr-code.title", {
          url: url.toString()
        }), value: url.toString(), size: QrSize, color: "var(--card-fg-color)", logoSize: QrCodeLogoSize + QrCodeLogoPadding }),
        /* @__PURE__ */ jsx(MotionMonogram, { initial: {
          opacity: -0.5
        }, animate: {
          opacity: 1.5
        }, exit: {
          opacity: 0
        } })
      ] }) }) : /* @__PURE__ */ jsx(MotionText, { muted: !0, size: 1, style: {
        maxWidth: "100px",
        textWrap: "pretty",
        textAlign: "center"
      }, initial: {
        opacity: 0
      }, animate: {
        opacity: 1
      }, exit: {
        opacity: 0
      }, children: t("share-preview-menu.qr-code.placeholder") }) }) }),
      /* @__PURE__ */ jsx(Text, { muted: !0, size: 1, children: t("share-preview-menu.qr-code.instructions") })
    ] }) }),
    /* @__PURE__ */ jsx(MenuDivider, {}),
    /* @__PURE__ */ jsx(MenuItem, { disabled: !url || disabling, icon: CopyIcon, onClick: handleCopyUrl, text: t("share-preview-menu.copy-url.text") })
  ] }) : /* @__PURE__ */ jsx(Card, { padding: 2, tone: "caution", radius: 3, children: /* @__PURE__ */ jsx(Text, { style: {
    textWrap: "pretty"
  }, children: t("share-preview-menu.error", {
    context: "missing-grants"
  }) }) }) }), popover: {
    constrainSize: !0,
    placement: "bottom",
    portal: !0
  } });
});
SharePreviewMenu.displayName = "Memo(SharePreviewMenu)";
const PreviewHeaderDefault = (props) => {
  const $ = c(97), {
    canSharePreviewAccess,
    canToggleSharePreviewAccess,
    canUseSharedPreviewAccess,
    dispatch,
    iframe,
    iframeRef,
    initialUrl,
    navigatorEnabled,
    onPathChange,
    onRefresh,
    openPopup,
    overlaysConnection,
    perspective,
    previewUrl,
    setViewport,
    targetOrigin,
    toggleNavigator,
    toggleOverlay,
    viewport,
    visualEditing: t0
  } = props, {
    overlaysEnabled
  } = t0, {
    t
  } = useTranslation(presentationLocaleNamespace);
  let t1;
  $[0] !== setViewport || $[1] !== viewport ? (t1 = () => setViewport(viewport === "desktop" ? "mobile" : "desktop"), $[0] = setViewport, $[1] = viewport, $[2] = t1) : t1 = $[2];
  const toggleViewportSize = t1;
  let t2;
  t2 = targetOrigin === location.origin ? "" : targetOrigin;
  const previewLocationOrigin = t2;
  let t3;
  $[3] !== dispatch || $[4] !== iframeRef.current || $[5] !== onRefresh || $[6] !== previewUrl || $[7] !== targetOrigin ? (t3 = () => {
    onRefresh(() => {
      iframeRef.current && (dispatch({
        type: ACTION_IFRAME_RELOAD
      }), Object.assign(iframeRef.current, {
        src: `${targetOrigin}${previewUrl || "/"}`
      }));
    });
  }, $[3] = dispatch, $[4] = iframeRef.current, $[5] = onRefresh, $[6] = previewUrl, $[7] = targetOrigin, $[8] = t3) : t3 = $[8];
  const handleRefresh = t3;
  let t4;
  const previewURL = new URL(previewUrl || "/", targetOrigin), {
    pathname,
    search
  } = withoutSecretSearchParams(previewURL);
  t4 = `${pathname}${search}`;
  const previewLocationRoute = t4;
  let t5;
  $[9] === Symbol.for("react.memo_cache_sentinel") ? (t5 = {
    width: "100%"
  }, $[9] = t5) : t5 = $[9];
  let t6;
  $[10] !== navigatorEnabled || $[11] !== t || $[12] !== toggleNavigator ? (t6 = toggleNavigator && /* @__PURE__ */ jsx(Button, { "aria-label": t("preview-frame.navigator.toggle-button.aria-label"), icon: PanelLeftIcon, mode: "bleed", onClick: toggleNavigator, selected: navigatorEnabled, tooltipProps: {
    content: /* @__PURE__ */ jsx(Text, { size: 1, children: t("preview-frame.navigator.toggle-button.tooltip") }),
    fallbackPlacements: ["bottom-start"],
    placement: "bottom"
  } }), $[10] = navigatorEnabled, $[11] = t, $[12] = toggleNavigator, $[13] = t6) : t6 = $[13];
  let t7;
  $[14] === Symbol.for("react.memo_cache_sentinel") ? (t7 = {
    whiteSpace: "nowrap"
  }, $[14] = t7) : t7 = $[14];
  const t8 = overlaysEnabled ? "disable" : "enable";
  let t9;
  $[15] !== t || $[16] !== t8 ? (t9 = t("preview-frame.overlay.toggle-button.tooltip", {
    context: t8
  }), $[15] = t, $[16] = t8, $[17] = t9) : t9 = $[17];
  let t10;
  $[18] !== t9 ? (t10 = /* @__PURE__ */ jsx(Box, { padding: 1, children: /* @__PURE__ */ jsx(Text, { size: 1, children: t9 }) }), $[18] = t9, $[19] = t10) : t10 = $[19];
  let t11;
  $[20] === Symbol.for("react.memo_cache_sentinel") ? (t11 = /* @__PURE__ */ jsx(Box, { paddingY: 1, children: /* @__PURE__ */ jsx(Hotkeys, { keys: ["Alt"], style: {
    marginTop: -4,
    marginBottom: -4
  } }) }), $[20] = t11) : t11 = $[20];
  let t12;
  $[21] !== t10 ? (t12 = /* @__PURE__ */ jsxs(Flex, { align: "center", style: t7, children: [
    t10,
    t11
  ] }), $[21] = t10, $[22] = t12) : t12 = $[22];
  let t13;
  $[23] === Symbol.for("react.memo_cache_sentinel") ? (t13 = ["bottom-start"], $[23] = t13) : t13 = $[23];
  let t14;
  $[24] === Symbol.for("react.memo_cache_sentinel") ? (t14 = {
    lineHeight: 0,
    borderRadius: 999,
    userSelect: "none"
  }, $[24] = t14) : t14 = $[24];
  const t15 = overlaysEnabled ? "transparent" : void 0;
  let t16;
  $[25] === Symbol.for("react.memo_cache_sentinel") ? (t16 = {
    margin: -4
  }, $[25] = t16) : t16 = $[25];
  const t17 = iframe.status === "loading" || overlaysConnection !== "connected";
  let t18;
  $[26] !== overlaysEnabled || $[27] !== t17 || $[28] !== toggleOverlay ? (t18 = /* @__PURE__ */ jsx("div", { style: t16, children: /* @__PURE__ */ jsx(Switch, { checked: overlaysEnabled, onChange: toggleOverlay, disabled: t17 }) }), $[26] = overlaysEnabled, $[27] = t17, $[28] = toggleOverlay, $[29] = t18) : t18 = $[29];
  const t19 = !overlaysEnabled;
  let t20;
  $[30] !== t ? (t20 = t("preview-frame.overlay.toggle-button.text"), $[30] = t, $[31] = t20) : t20 = $[31];
  let t21;
  $[32] !== t19 || $[33] !== t20 ? (t21 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text, { muted: t19, size: 1, weight: "medium", children: t20 }) }), $[32] = t19, $[33] = t20, $[34] = t21) : t21 = $[34];
  let t22;
  $[35] !== t18 || $[36] !== t21 ? (t22 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, children: [
    t18,
    t21
  ] }), $[35] = t18, $[36] = t21, $[37] = t22) : t22 = $[37];
  let t23;
  $[38] !== t15 || $[39] !== t22 ? (t23 = /* @__PURE__ */ jsx(Card, { as: "label", flex: "none", padding: 3, marginX: 1, style: t14, tone: t15, children: t22 }), $[38] = t15, $[39] = t22, $[40] = t23) : t23 = $[40];
  let t24;
  $[41] !== t12 || $[42] !== t23 ? (t24 = /* @__PURE__ */ jsx(Tooltip, { animate: !0, content: t12, fallbackPlacements: t13, placement: "bottom", portal: !0, children: t23 }), $[41] = t12, $[42] = t23, $[43] = t24) : t24 = $[43];
  let t25;
  $[44] !== iframe.status || $[45] !== t ? (t25 = iframe.status === "loaded" ? t("preview-frame.refresh-button.tooltip") : t("preview-frame.status", {
    context: iframe.status
  }), $[44] = iframe.status, $[45] = t, $[46] = t25) : t25 = $[46];
  let t26;
  $[47] !== t25 ? (t26 = /* @__PURE__ */ jsx(Text, { size: 1, children: t25 }), $[47] = t25, $[48] = t26) : t26 = $[48];
  let t27;
  $[49] === Symbol.for("react.memo_cache_sentinel") ? (t27 = ["bottom-end"], $[49] = t27) : t27 = $[49];
  let t28;
  $[50] !== t ? (t28 = t("preview-frame.refresh-button.aria-label"), $[50] = t, $[51] = t28) : t28 = $[51];
  const t29 = iframe.status === "reloading" || iframe.status === "refreshing";
  let t30;
  $[52] !== handleRefresh || $[53] !== t28 || $[54] !== t29 ? (t30 = /* @__PURE__ */ jsx(Button, { "aria-label": t28, icon: RefreshIcon, mode: "bleed", loading: t29, onClick: handleRefresh, tooltipProps: null }), $[52] = handleRefresh, $[53] = t28, $[54] = t29, $[55] = t30) : t30 = $[55];
  let t31;
  $[56] !== t26 || $[57] !== t30 ? (t31 = /* @__PURE__ */ jsx(Box, { padding: 1, children: /* @__PURE__ */ jsx(Tooltip, { animate: !0, content: t26, fallbackPlacements: t27, placement: "bottom", portal: !0, children: t30 }) }), $[56] = t26, $[57] = t30, $[58] = t31) : t31 = $[58];
  let t32;
  $[59] !== openPopup || $[60] !== previewLocationOrigin || $[61] !== previewLocationRoute ? (t32 = /* @__PURE__ */ jsx(Box, { padding: 1, children: /* @__PURE__ */ jsx(OpenPreviewButton, { openPopup, previewLocationOrigin, previewLocationRoute }) }), $[59] = openPopup, $[60] = previewLocationOrigin, $[61] = previewLocationRoute, $[62] = t32) : t32 = $[62];
  let t33;
  $[63] !== onPathChange || $[64] !== previewLocationOrigin || $[65] !== previewLocationRoute || $[66] !== t31 || $[67] !== t32 ? (t33 = /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(PreviewLocationInput, { prefix: t31, onChange: onPathChange, origin: previewLocationOrigin, suffix: t32, value: previewLocationRoute }) }), $[63] = onPathChange, $[64] = previewLocationOrigin, $[65] = previewLocationRoute, $[66] = t31, $[67] = t32, $[68] = t33) : t33 = $[68];
  const t34 = viewport === "desktop" ? "narrow" : "full";
  let t35;
  $[69] !== t || $[70] !== t34 ? (t35 = t("preview-frame.viewport-button.tooltip", {
    context: t34
  }), $[69] = t, $[70] = t34, $[71] = t35) : t35 = $[71];
  let t36;
  $[72] !== t35 ? (t36 = /* @__PURE__ */ jsx(Text, { size: 1, children: t35 }), $[72] = t35, $[73] = t36) : t36 = $[73];
  let t37;
  $[74] === Symbol.for("react.memo_cache_sentinel") ? (t37 = ["bottom-start"], $[74] = t37) : t37 = $[74];
  let t38;
  $[75] !== t ? (t38 = t("preview-frame.viewport-button.aria-label"), $[75] = t, $[76] = t38) : t38 = $[76];
  const t39 = viewport === "desktop" ? MobileDeviceIcon : DesktopIcon;
  let t40;
  $[77] !== t38 || $[78] !== t39 || $[79] !== toggleViewportSize ? (t40 = /* @__PURE__ */ jsx(Button, { "aria-label": t38, icon: t39, mode: "bleed", onClick: toggleViewportSize, tooltipProps: null }), $[77] = t38, $[78] = t39, $[79] = toggleViewportSize, $[80] = t40) : t40 = $[80];
  let t41;
  $[81] !== t36 || $[82] !== t40 ? (t41 = /* @__PURE__ */ jsx(Flex, { align: "center", flex: "none", gap: 1, children: /* @__PURE__ */ jsx(Tooltip, { animate: !0, content: t36, fallbackPlacements: t37, placement: "bottom", portal: !0, children: t40 }) }), $[81] = t36, $[82] = t40, $[83] = t41) : t41 = $[83];
  let t42;
  $[84] !== canSharePreviewAccess || $[85] !== canToggleSharePreviewAccess || $[86] !== canUseSharedPreviewAccess || $[87] !== initialUrl || $[88] !== perspective || $[89] !== previewLocationRoute ? (t42 = canSharePreviewAccess && /* @__PURE__ */ jsx(Flex, { align: "center", flex: "none", gap: 1, children: /* @__PURE__ */ jsx(SharePreviewMenu, { canToggleSharePreviewAccess, canUseSharedPreviewAccess, previewLocationRoute, initialUrl, perspective }) }), $[84] = canSharePreviewAccess, $[85] = canToggleSharePreviewAccess, $[86] = canUseSharedPreviewAccess, $[87] = initialUrl, $[88] = perspective, $[89] = previewLocationRoute, $[90] = t42) : t42 = $[90];
  let t43;
  return $[91] !== t24 || $[92] !== t33 || $[93] !== t41 || $[94] !== t42 || $[95] !== t6 ? (t43 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 1, paddingX: 1, style: t5, children: [
    t6,
    t24,
    t33,
    t41,
    t42
  ] }), $[91] = t24, $[92] = t33, $[93] = t41, $[94] = t42, $[95] = t6, $[96] = t43) : t43 = $[96], t43;
};
function PreviewHeader(props) {
  const $ = c(7), renderDefault = _temp$2, HeaderComponent = props.options?.component;
  let t0;
  $[0] !== HeaderComponent || $[1] !== props ? (t0 = HeaderComponent ? /* @__PURE__ */ jsx(HeaderComponent, { ...props, renderDefault }) : renderDefault(props), $[0] = HeaderComponent, $[1] = props, $[2] = t0) : t0 = $[2];
  const header = t0;
  let t1;
  $[3] === Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    position: "relative"
  }, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] === Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    minHeight: 0
  }, $[4] = t2) : t2 = $[4];
  let t3;
  return $[5] !== header ? (t3 = /* @__PURE__ */ jsx(Card, { flex: "none", padding: 2, borderBottom: !0, style: t1, children: /* @__PURE__ */ jsx(Flex, { align: "center", style: t2, children: header }) }), $[5] = header, $[6] = t3) : t3 = $[6], t3;
}
function _temp$2(props_0) {
  return /* @__PURE__ */ jsx(PreviewHeaderDefault, { ...props_0 });
}
function usePresentationPreviewHeader(props) {
  const $ = c(2);
  let t0;
  return $[0] !== props ? (t0 = () => /* @__PURE__ */ jsx(PreviewHeader, { ...props }), $[0] = props, $[1] = t0) : t0 = $[1], t0;
}
const MotionFlex = motion.create(Flex), Preview = memo(forwardRef(function(props, forwardedRef) {
  const {
    dispatch,
    iframe,
    header,
    initialUrl,
    loadersConnection,
    overlaysConnection,
    perspective,
    viewport,
    vercelProtectionBypass
  } = props, [stablePerspective, setStablePerspective] = useState(null), urlPerspective = encodeStudioPerspective(stablePerspective === null ? perspective : stablePerspective), previewUrl = useMemo(() => {
    const url = new URL(initialUrl);
    return url.searchParams.get(urlSearchParamPreviewPerspective) || url.searchParams.set(urlSearchParamPreviewPerspective, urlPerspective), (vercelProtectionBypass || url.searchParams.get(urlSearchParamVercelProtectionBypass)) && url.searchParams.set(urlSearchParamVercelSetBypassCookie, "samesitenone"), vercelProtectionBypass && !url.searchParams.get(urlSearchParamVercelProtectionBypass) && url.searchParams.set(urlSearchParamVercelProtectionBypass, vercelProtectionBypass), url;
  }, [initialUrl, urlPerspective, vercelProtectionBypass]);
  useEffect(() => {
    loadersConnection === "connected" && setStablePerspective((prev) => prev === null ? perspective : prev);
  }, [loadersConnection, perspective]);
  const {
    t
  } = useTranslation(presentationLocaleNamespace), {
    devMode
  } = usePresentationTool(), prefersReducedMotion = usePrefersReducedMotion(), ref = useRef(null), PreviewHeader2 = usePresentationPreviewHeader({
    ...props,
    iframeRef: ref,
    options: header
  });
  useImperativeHandle(forwardedRef, () => ref.current);
  const loading = iframe.status === "loading" || iframe.status === "reloading", [timedOut, setTimedOut] = useState(!1), refreshing = iframe.status === "refreshing", [somethingIsWrong, setSomethingIsWrong] = useState(!1), iframeIsBusy = loading || refreshing || overlaysConnection === "connecting", handleRetry = useCallback(() => {
    ref.current && (ref.current.src = previewUrl.toString(), dispatch({
      type: ACTION_IFRAME_RELOAD
    }));
  }, [dispatch, previewUrl]), handleContinueAnyway = useCallback(() => {
    setContinueAnyway(!0);
  }, []), [continueAnyway, setContinueAnyway] = useState(!1), [showOverlaysConnectionStatus, setShowOverlaysConnectionState] = useState(!1);
  useEffect(() => {
    if (!(loading || refreshing) && (overlaysConnection === "connecting" || overlaysConnection === "reconnecting")) {
      const timeout = setTimeout(() => {
        setShowOverlaysConnectionState(!0);
      }, 5e3);
      return () => clearTimeout(timeout);
    }
  }, [overlaysConnection, loading, refreshing]), useEffect(() => {
    if (!(loading || refreshing || !showOverlaysConnectionStatus)) {
      if (overlaysConnection === "connected" && (setSomethingIsWrong(!1), setShowOverlaysConnectionState(!1), setTimedOut(!1), setContinueAnyway(!1)), overlaysConnection === "connecting") {
        const timeout_0 = setTimeout(() => {
          setTimedOut(!0), console.error("Unable to connect to visual editing. Make sure you've setup '@sanity/visual-editing' correctly");
        }, MAX_TIME_TO_OVERLAYS_CONNECTION);
        return () => clearTimeout(timeout_0);
      }
      if (overlaysConnection === "reconnecting") {
        const timeout_1 = setTimeout(() => {
          setTimedOut(!0), setSomethingIsWrong(!0);
        }, MAX_TIME_TO_OVERLAYS_CONNECTION);
        return () => clearTimeout(timeout_1);
      }
    }
  }, [loading, overlaysConnection, refreshing, showOverlaysConnectionStatus]);
  const onIFrameLoad = useCallback(() => {
    dispatch({
      type: ACTION_IFRAME_LOADED
    });
  }, [dispatch]);
  useEffect(() => {
    if (!ref.current)
      return;
    const instance = ref.current;
    function handleBlur() {
      instance === document.activeElement && instance.dispatchEvent(new MouseEvent("mousedown", {
        bubbles: !0,
        cancelable: !0
      }));
    }
    return window.addEventListener("blur", handleBlur), () => {
      window.removeEventListener("blur", handleBlur);
    };
  }, []);
  const preventIframeInteraction = useMemo(() => (loading || overlaysConnection === "connecting" && iframe.status !== "refreshing") && !continueAnyway, [continueAnyway, iframe.status, loading, overlaysConnection]), canUseViewTransition = useSyncExternalStore(
    // eslint-disable-next-line no-empty-function
    useCallback(() => () => {
    }, []),
    () => CSS.supports("(view-transition-name: test)")
  ), iframeAnimations = useMemo(() => [
    preventIframeInteraction ? "background" : "active",
    loading ? "reloading" : "idle",
    // If CSS View Transitions are supported, then transition iframe viewport dimensions with that instead of Motion
    canUseViewTransition ? "" : viewport,
    showOverlaysConnectionStatus && !continueAnyway ? "timedOut" : ""
  ], [canUseViewTransition, continueAnyway, loading, preventIframeInteraction, showOverlaysConnectionStatus, viewport]), [currentViewport, setCurrentViewport] = useState(viewport), [iframeStyle, setIframeStyle] = useState(iframeVariants[viewport]);
  return useEffect(() => {
    if (canUseViewTransition && viewport !== currentViewport) {
      const update = () => {
        setCurrentViewport(viewport), setIframeStyle(iframeVariants[viewport]);
      };
      !prefersReducedMotion && "startViewTransition" in document && typeof document.startViewTransition == "function" ? document.startViewTransition(() => flushSync(() => update())) : update();
    }
  }, [canUseViewTransition, prefersReducedMotion, currentViewport, viewport]), /* @__PURE__ */ jsx(MotionConfig, { transition: prefersReducedMotion ? {
    duration: 0
  } : void 0, children: /* @__PURE__ */ jsxs(TooltipDelayGroupProvider, { children: [
    /* @__PURE__ */ jsx(PreviewHeader2, {}),
    /* @__PURE__ */ jsx(Card, { flex: 1, tone: "transparent", children: /* @__PURE__ */ jsxs(Flex, { align: "center", height: "fill", justify: "center", padding: (canUseViewTransition ? currentViewport : viewport) === "desktop" ? 0 : 2, sizing: "border", style: {
      position: "relative",
      cursor: iframeIsBusy ? "wait" : void 0
    }, children: [
      /* @__PURE__ */ jsx(AnimatePresence, { children: !somethingIsWrong && !loading && !refreshing && // viewport, // using CSS View Transitions instead of framer motion to drive this
      showOverlaysConnectionStatus && !continueAnyway ? /* @__PURE__ */ jsx(MotionFlex, { initial: "initial", animate: "animate", exit: "exit", variants: spinnerVariants, justify: "center", align: "center", style: {
        inset: "0",
        position: "absolute",
        backdropFilter: timedOut ? "blur(16px) saturate(0.5) grayscale(0.5)" : "blur(2px)",
        transition: "backdrop-filter 0.2s ease-in-out",
        // @TODO Because of Safari we have to do this
        WebkitBackdropFilter: timedOut ? "blur(16px) saturate(0.5) grayscale(0.5)" : "blur(2px)",
        WebkitTransition: "-webkit-backdrop-filter 0.2s ease-in-out",
        zIndex: 1
      }, children: /* @__PURE__ */ jsxs(Flex, { style: {
        ...sizes[viewport]
      }, justify: "center", align: "center", direction: "column", gap: 4, children: [
        timedOut && /* @__PURE__ */ jsx(Button, { disabled: !0, mode: "ghost", text: t("preview-frame.continue-button.text"), style: {
          opacity: 0
        } }),
        /* @__PURE__ */ jsx(Card, { radius: 2, tone: timedOut ? "caution" : "inherit", padding: 4, shadow: 1, children: /* @__PURE__ */ jsxs(Flex, { justify: "center", align: "center", direction: "column", gap: 4, children: [
          /* @__PURE__ */ jsx(Spinner, { muted: !0 }),
          /* @__PURE__ */ jsx(Text, { muted: !0, size: 1, children: timedOut ? t("preview-frame.status", {
            context: "timeout"
          }) : t("preview-frame.status", {
            context: "connecting"
          }) })
        ] }) }),
        timedOut && /* @__PURE__ */ jsx(
          Button,
          {
            tone: "critical",
            onClick: handleContinueAnyway,
            text: t("preview-frame.continue-button.text")
          }
        )
      ] }) }) : (loading || overlaysConnection === "connecting" && iframe.status !== "refreshing") && !continueAnyway ? /* @__PURE__ */ jsx(MotionFlex, { initial: "initial", animate: "animate", exit: "exit", variants: spinnerVariants, justify: "center", align: "center", style: {
        inset: "0",
        position: "absolute"
        // boxShadow: '0 0 0 1px var(--card-shadow-outline-color)',
      }, children: /* @__PURE__ */ jsxs(Flex, { style: {
        ...sizes[viewport]
      }, justify: "center", align: "center", direction: "column", gap: 4, children: [
        /* @__PURE__ */ jsx(Spinner, { muted: !0 }),
        /* @__PURE__ */ jsx(Text, { muted: !0, size: 1, children: t("preview-frame.status", {
          context: "loading"
        }) })
      ] }) }) : somethingIsWrong && !continueAnyway ? /* @__PURE__ */ jsx(MotionFlex, { initial: "initial", animate: "animate", exit: "exit", variants: errorVariants, justify: "center", align: "center", style: {
        background: "var(--card-bg-color)",
        inset: "0",
        position: "absolute"
      }, children: /* @__PURE__ */ jsx(ErrorCard, { flex: 1, message: t("preview-frame.connection.error.text"), onRetry: handleRetry, onContinueAnyway: handleContinueAnyway, children: devMode && /* @__PURE__ */ jsxs(Fragment, { children: [
        overlaysConnection !== "connected" && /* @__PURE__ */ jsx(Card, { padding: 3, radius: 2, tone: "critical", children: /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
          /* @__PURE__ */ jsx(Label, { muted: !0, size: 0, children: t("preview-frame.overlay.connection-status.label") }),
          /* @__PURE__ */ jsx(Code, { size: 1, children: t("channel.status", {
            context: overlaysConnection
          }) })
        ] }) }),
        loadersConnection !== "connected" && /* @__PURE__ */ jsx(Card, { padding: 3, radius: 2, tone: "critical", children: /* @__PURE__ */ jsxs(Stack, { space: 3, children: [
          /* @__PURE__ */ jsx(Label, { muted: !0, size: 0, children: t("preview-frame.loader.connection-status.label") }),
          /* @__PURE__ */ jsx(Code, { size: 1, children: t("channel.status", {
            context: loadersConnection
          }) })
        ] }) })
      ] }) }) }) : null }),
      /* @__PURE__ */ jsx(IFrame, { animate: iframeAnimations, initial: ["background"], onLoad: onIFrameLoad, preventClick: preventIframeInteraction, ref, src: previewUrl.toString(), style: iframeStyle, variants: iframeVariants })
    ] }) })
  ] }) });
}));
Preview.displayName = "Memo(ForwardRef(Preview))";
const sizes = {
  desktop: {
    width: "100%",
    height: "100%"
  },
  mobile: {
    width: 375,
    height: 650
  }
}, spinnerVariants = {
  initial: {
    opacity: 1
  },
  animate: {
    opacity: [0, 0, 1]
  },
  exit: {
    opacity: [1, 0, 0]
  }
}, errorVariants = {
  initial: {
    opacity: 1
  },
  animate: {
    opacity: [0, 0, 1]
  },
  exit: {
    opacity: [1, 0, 0]
  }
}, iframeVariants = {
  desktop: {
    ...sizes.desktop,
    boxShadow: "0 0 0 0px var(--card-border-color)"
  },
  mobile: {
    ...sizes.mobile,
    boxShadow: "0 0 0 1px var(--card-border-color)"
  },
  background: {
    opacity: 0,
    scale: 1
  },
  idle: {
    scale: 1
  },
  reloading: {
    scale: [1, 1, 1, 0.98]
  },
  active: {
    opacity: [0, 0, 1],
    scale: 1
  },
  timedOut: {
    opacity: [0, 0, 1]
  }
};
function defineWarnOnce() {
  let warned = !1;
  return (...args) => {
    warned || (console.warn(...args), warned = !0);
  };
}
const warnOnceAboutCrossDatasetReference = defineWarnOnce();
function useDocumentsOnPage(perspective, frameStateRef) {
  validateApiPerspective(perspective);
  const [published, setPublished] = useState({}), [previewDrafts, setPreviewDrafts] = useState({}), urlRef = useRef(""), setDocumentsOnPage = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-shadow
    (key, perspective_0, sourceDocuments = []) => {
      const documents = sourceDocuments.filter((sourceDocument) => "_projectId" in sourceDocument && sourceDocument._projectId ? (warnOnceAboutCrossDatasetReference("Cross dataset references are not supported yet, ignoring source document", sourceDocument), !1) : sourceDocument);
      (perspective_0 === "published" ? setPublished : setPreviewDrafts)((cache) => {
        const next = {};
        for (const document2 of documents)
          next[document2._id] = document2;
        if (urlRef.current !== frameStateRef.current.url)
          return urlRef.current = frameStateRef.current.url, {
            [key]: next
          };
        const prev = cache[key];
        return isEqual(prev, next) ? cache : {
          ...cache,
          [key]: next
        };
      });
    },
    [frameStateRef]
  );
  return [useMemo(() => {
    const uniqueDocuments = Object.values(perspective === "published" ? published : previewDrafts).reduce((acc, cache_0) => (Object.values(cache_0).forEach((doc) => {
      acc[doc._id] = doc;
    }), acc), {});
    return Object.values(uniqueDocuments);
  }, [perspective, previewDrafts, published]), setDocumentsOnPage];
}
function fnOrObj(arg, context) {
  return arg instanceof Function ? arg(context) : arg;
}
function getQueryFromResult(resolver, context) {
  if (resolver.resolve) {
    const filter = resolver.resolve(context)?.filter;
    return filter ? `// groq
*[${filter}][0]{_id, _type}` : void 0;
  }
  return "type" in resolver ? `// groq
*[_type == "${resolver.type}"][0]{_id, _type}` : `// groq
*[${fnOrObj(resolver.filter, context)}][0]{_id, _type}`;
}
function getParamsFromResult(resolver, context) {
  return resolver.resolve ? resolver.resolve(context)?.params ?? context.params : "type" in resolver ? {} : fnOrObj(resolver.params, context) ?? context.params;
}
function getRouteContext(route, url) {
  const routes = Array.isArray(route) ? route : [route];
  for (route of routes) {
    let origin, path = route;
    if (typeof route == "string")
      try {
        const absolute = new URL(route);
        origin = absolute.origin, path = absolute.pathname;
      } catch {
      }
    if (!(origin && url.origin !== origin))
      try {
        const result = match(path, {
          decode: decodeURIComponent
        })(url.pathname);
        if (result) {
          const {
            params,
            path: path2
          } = result;
          return {
            origin,
            params,
            path: path2
          };
        }
      } catch {
        throw new Error(`"${route}" is not a valid route pattern`);
      }
  }
}
function useMainDocument(props) {
  const {
    navigate,
    navigationHistory,
    path,
    previewUrl,
    resolvers = []
  } = props, {
    state: routerState
  } = useRouter(), client = useClient({
    apiVersion: API_VERSION
  }), relativeUrl = path || routerState._searchParams?.find(([key]) => key === "preview")?.[1] || "", [mainDocumentState, setMainDocumentState] = useState(void 0), mainDocumentIdRef = useRef(void 0), handleResponse = useEffectEvent((doc, url) => {
    (!doc || mainDocumentIdRef.current !== doc._id) && (setMainDocumentState({
      document: doc,
      path: url.pathname
    }), mainDocumentIdRef.current = doc?._id, navigationHistory.at(-1)?.id === navigationHistory.at(-2)?.id && navigate?.({
      id: doc?._id,
      type: doc?._type
    }));
  });
  return useEffect(() => {
    const base = (
      // eslint-disable-next-line no-nested-ternary
      typeof previewUrl == "string" ? previewUrl : typeof previewUrl == "object" && previewUrl?.origin || location.origin
    ), url_0 = new URL(relativeUrl, base);
    if (resolvers.length) {
      let result;
      for (const resolver of resolvers) {
        const context = getRouteContext(resolver.route, url_0);
        if (context) {
          result = {
            context,
            resolver
          };
          break;
        }
      }
      if (result) {
        const query = getQueryFromResult(result.resolver, result.context), params = getParamsFromResult(result.resolver, result.context);
        if (query) {
          const controller = new AbortController(), options = {
            perspective: "previewDrafts",
            signal: controller.signal
          };
          return client.fetch(query, params, options).then((doc_0) => handleResponse(doc_0, url_0)).catch((e) => {
            e instanceof Error && e.name === "AbortError" || (setMainDocumentState({
              document: void 0,
              path: url_0.pathname
            }), mainDocumentIdRef.current = void 0);
          }), () => {
            controller.abort();
          };
        }
      }
    }
    setMainDocumentState(void 0), mainDocumentIdRef.current = void 0;
  }, [client, handleResponse, previewUrl, relativeUrl, resolvers]), mainDocumentState;
}
const lengthyStr$1 = pipe(string(), minLength(1)), optionalLengthyStr = optional(lengthyStr$1);
object({
  baseUrl: lengthyStr$1,
  dataset: optionalLengthyStr,
  id: lengthyStr$1,
  path: lengthyStr$1,
  projectId: optionalLengthyStr,
  tool: optionalLengthyStr,
  type: optionalLengthyStr,
  workspace: optionalLengthyStr
});
const RE_SEGMENT_WITH_INDEX = /^([\w-]+):(0|[1-9][0-9]*)$/, RE_SEGMENT_WITH_TUPLE = /^([\w-]+):([0-9]+),([0-9]+)$/, RE_SEGMENT_WITH_KEY = /^([\w-]+):([\w-]+)$/;
function urlStringToPath(str) {
  const path = [];
  for (const segment of str.split(".")) {
    const withIndex = RE_SEGMENT_WITH_INDEX.exec(segment);
    if (withIndex) {
      path.push(withIndex[1], Number(withIndex[2]));
      continue;
    }
    const withTuple = RE_SEGMENT_WITH_TUPLE.exec(segment);
    if (withTuple) {
      path.push(withTuple[1], [Number(withTuple[2]), Number(withTuple[3])]);
      continue;
    }
    const withKey = RE_SEGMENT_WITH_KEY.exec(segment);
    if (withKey) {
      path.push(withKey[1], {
        _key: withKey[2]
      });
      continue;
    }
    path.push(segment);
  }
  return path;
}
const lengthyStr = pipe(string(), minLength(1));
object({
  origin: lengthyStr,
  href: lengthyStr,
  data: optional(record(string(), unknown()))
});
function parseId(rawId) {
  if (rawId === void 0)
    return;
  const segments = decodeURIComponent(rawId)?.split(".");
  return segments[0] === "drafts" && segments.shift(), segments.join(".");
}
function parsePath(rawPath) {
  if (rawPath !== void 0)
    return studioPath.toString(urlStringToPath(decodeURIComponent(rawPath)));
}
function parseRouterState(state) {
  return {
    id: parseId(state.id),
    path: parsePath(state.path),
    type: state.type
  };
}
function pruneObject(obj) {
  return Object.fromEntries(Object.entries(obj).filter(([, value]) => value !== void 0 && value !== "" && value !== null));
}
function useParams({
  initialPreviewUrl,
  routerNavigate,
  routerState,
  routerSearchParams,
  frameStateRef
}) {
  const params = useMemo(() => {
    const {
      id,
      path,
      type
    } = parseRouterState(routerState);
    return {
      id,
      type,
      path,
      preview: routerSearchParams.preview || `${initialPreviewUrl.pathname}${initialPreviewUrl.search}`,
      perspective: routerSearchParams.perspective,
      viewport: routerSearchParams.viewport,
      inspect: routerSearchParams.inspect,
      rev: routerSearchParams.rev,
      since: routerSearchParams.since,
      template: routerSearchParams.template,
      templateParams: routerSearchParams.templateParams,
      view: routerSearchParams.view,
      // assist
      pathKey: routerSearchParams.pathKey,
      instruction: routerSearchParams.instruction,
      // comments
      comment: routerSearchParams.comment,
      changesInspectorTab: routerSearchParams.changesInspectorTab
    };
  }, [routerState, routerSearchParams, initialPreviewUrl]), structureParams = useMemo(() => pruneObject({
    inspect: params.inspect,
    path: params.path,
    rev: params.rev,
    since: params.since,
    template: params.template,
    templateParams: params.templateParams,
    view: params.view,
    // assist
    pathKey: params.pathKey,
    instruction: params.instruction,
    // comments
    comment: params.comment,
    changesInspectorTab: params.changesInspectorTab
  }), [params.changesInspectorTab, params.comment, params.inspect, params.instruction, params.path, params.pathKey, params.rev, params.since, params.template, params.templateParams, params.view]), searchParams = useMemo(() => pruneObject({
    perspective: params.perspective,
    preview: params.preview,
    viewport: params.viewport
  }), [params.perspective, params.preview, params.viewport]), routerStateRef = useRef(routerState);
  useEffect(() => {
    routerStateRef.current = routerState;
  }, [routerState]);
  const [navigationHistory, setNavigationHistory] = useState([routerState]);
  return {
    navigate: useCallback((nextState, nextSearchState = {}, forceReplace) => {
      nextState.id && (nextState.id = getPublishedId(nextState.id));
      const {
        _searchParams: routerSearchParams_0,
        ...routerState_0
      } = routerStateRef.current, routerSearchState = (routerSearchParams_0 || []).reduce((acc, [key, value]) => (acc[key] = value, acc), {}), state = pruneObject({
        ...routerState_0,
        ...nextState
      }), searchState = pruneObject({
        ...routerSearchState,
        ...nextSearchState
      });
      routerState_0.id !== state.id && (delete searchState.template, delete searchState.templateParams), state._searchParams = Object.entries(searchState).reduce((acc_0, [key_0, value_0]) => [...acc_0, [key_0, value_0]], []);
      const replace = forceReplace ?? searchState.preview === frameStateRef.current.url;
      setNavigationHistory((prev) => [...prev, state]), routerNavigate(state, {
        replace
      });
    }, [routerNavigate, frameStateRef]),
    navigationHistory,
    params,
    searchParams,
    structureParams
  };
}
const usePopups = (controller) => {
  const [popups, setPopups] = useState(() => /* @__PURE__ */ new Set()), open = useCallback((url) => {
    const source = window.open(url, "_blank");
    source && setPopups((prev) => new Set(prev).add(source));
  }, []);
  return useEffect(() => {
    const unsubs = [];
    if (popups.size && controller)
      for (const source_0 of popups)
        source_0 && "closed" in source_0 && !source_0.closed && unsubs.push(controller.addTarget(source_0));
    return () => {
      unsubs.forEach((unsub) => unsub());
    };
  }, [controller, popups]), useEffect(() => {
    if (popups.size) {
      const interval = setInterval(() => {
        const closed = /* @__PURE__ */ new Set();
        for (const source_1 of popups)
          source_1 && "closed" in source_1 && source_1.closed && closed.add(source_1);
        closed.size && setPopups((prev_0) => {
          const next = new Set(prev_0);
          for (const source_2 of closed)
            next.delete(source_2);
          return next;
        });
      }, POPUP_CHECK_INTERVAL);
      return () => {
        clearInterval(interval);
      };
    }
  }, [popups]), {
    popups,
    open
  };
};
function usePreviewUrl(previewUrl, toolName, studioPreviewPerspective, previewSearchParam, canCreateUrlPreviewSecrets) {
  const client = useClient({
    apiVersion: API_VERSION
  }), workspace = useActiveWorkspace(), basePath = workspace?.activeWorkspace?.basePath || "/", workspaceName = workspace?.activeWorkspace?.name || "default", deps = useSuspendCacheKeys(toolName, basePath, workspaceName, previewSearchParam), previewUrlSecret = usePreviewUrlSecret(canCreateUrlPreviewSecrets && typeof previewUrl == "object" || typeof previewUrl == "function", deps);
  return suspend(async () => {
    if (typeof previewUrl == "string") {
      const resolvedUrl2 = new URL(previewUrl, location.origin);
      let resultUrl = resolvedUrl2;
      try {
        if (previewSearchParam) {
          const restoredUrl = new URL(previewSearchParam, resolvedUrl2);
          restoredUrl.origin === resolvedUrl2.origin && (resultUrl = restoredUrl);
        }
      } catch {
      }
      return location.origin === resultUrl.origin && (resultUrl.pathname.startsWith(`${basePath}/`) || resultUrl.pathname === basePath) ? resolvedUrl2 : resultUrl;
    }
    const resolvedUrl = await (typeof previewUrl == "object" ? definePreviewUrl(previewUrl) : previewUrl)({
      client,
      previewUrlSecret,
      studioPreviewPerspective: encodeStudioPerspective(studioPreviewPerspective),
      previewSearchParam,
      studioBasePath: basePath
    });
    return new URL(resolvedUrl, location.origin);
  }, [...deps, previewUrlSecret]);
}
const resolveUUID = Symbol("sanity/presentation/resolveUUID");
function useSuspendCacheKeys(toolName, basePath, workspaceName, previewSearchParam) {
  const $ = c(12);
  let t0;
  $[0] !== previewSearchParam ? (t0 = () => previewSearchParam || "", $[0] = previewSearchParam, $[1] = t0) : t0 = $[1];
  const [cachedPreviewSearchParam, setCachedPreviewSearchParam] = useState(t0), timeoutRef = useRef(0);
  let t1, t2;
  $[2] !== cachedPreviewSearchParam || $[3] !== previewSearchParam ? (t1 = () => {
    if (cachedPreviewSearchParam && previewSearchParam)
      return window.clearTimeout(timeoutRef.current), () => {
        timeoutRef.current = window.setTimeout(() => {
          setCachedPreviewSearchParam("");
        }, 100);
      };
  }, t2 = [cachedPreviewSearchParam, previewSearchParam], $[2] = cachedPreviewSearchParam, $[3] = previewSearchParam, $[4] = t1, $[5] = t2) : (t1 = $[4], t2 = $[5]), useEffect(t1, t2);
  const currentUser = useCurrentUser();
  let t3;
  const t4 = currentUser?.id;
  let t5;
  return $[6] !== basePath || $[7] !== cachedPreviewSearchParam || $[8] !== t4 || $[9] !== toolName || $[10] !== workspaceName ? (t5 = ["sanity/presentation", basePath, workspaceName, toolName, t4, resolveUUID, cachedPreviewSearchParam], $[6] = basePath, $[7] = cachedPreviewSearchParam, $[8] = t4, $[9] = toolName, $[10] = workspaceName, $[11] = t5) : t5 = $[11], t3 = t5, t3;
}
function usePreviewUrlSecret(enabled, deps) {
  const $ = c(10);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    apiVersion: API_VERSION
  }, $[0] = t0) : t0 = $[0];
  const client = useClient(t0), currentUser = useCurrentUser(), [secretLastExpiredAt, setSecretLastExpiredAt] = useState("");
  let t1;
  $[1] !== client || $[2] !== currentUser?.id || $[3] !== deps || $[4] !== enabled || $[5] !== secretLastExpiredAt ? (t1 = enabled ? suspend(async () => await createPreviewSecret(client, "@sanity/presentation", typeof window > "u" ? "" : location.href, currentUser?.id), [...deps, secretLastExpiredAt]) : null, $[1] = client, $[2] = currentUser?.id, $[3] = deps, $[4] = enabled, $[5] = secretLastExpiredAt, $[6] = t1) : t1 = $[6];
  const previewUrlSecret = t1;
  let t2, t3;
  return $[7] !== previewUrlSecret ? (t2 = () => {
    if (!previewUrlSecret)
      return;
    const timeout = setTimeout(() => {
      startTransition(() => setSecretLastExpiredAt(previewUrlSecret.expiresAt.toString()));
    }, previewUrlSecret.expiresAt.getTime() - Date.now());
    return () => clearTimeout(timeout);
  }, t3 = [previewUrlSecret], $[7] = previewUrlSecret, $[8] = t2, $[9] = t3) : (t2 = $[8], t3 = $[9]), useEffect(t2, t3), previewUrlSecret?.secret || null;
}
function useStatus() {
  const $ = c(4);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ new Map(), $[0] = t0) : t0 = $[0];
  const [statusMap, setStatusMap] = useState(t0);
  let t1;
  bb0: {
    const values = Array.from(statusMap.values());
    if (values.find(_temp$1)) {
      t1 = "connected";
      break bb0;
    }
    const handshaking = values.filter(_temp2);
    if (handshaking.length) {
      t1 = handshaking.some(_temp3) ? "connecting" : "reconnecting";
      break bb0;
    }
    t1 = "idle";
  }
  const memoStatus = t1;
  let t2;
  $[1] === Symbol.for("react.memo_cache_sentinel") ? (t2 = (event) => {
    setStatusMap((prev) => {
      const next = new Map(prev);
      if (event.status === "disconnected")
        next.delete(event.connection);
      else {
        const hasConnected_0 = next.get(event.connection)?.hasConnected || event.status === "connected", status_1 = event.status === "handshaking" ? "connecting" : event.status;
        next.set(event.connection, {
          status: status_1,
          hasConnected: hasConnected_0
        });
      }
      return next;
    });
  }, $[1] = t2) : t2 = $[1];
  const setStatusFromEvent = t2;
  let t3;
  return $[2] !== memoStatus ? (t3 = [memoStatus, setStatusFromEvent], $[2] = memoStatus, $[3] = t3) : t3 = $[3], t3;
}
function _temp3(t0) {
  const {
    hasConnected
  } = t0;
  return !hasConnected;
}
function _temp2(t0) {
  const {
    status: status_0
  } = t0;
  return status_0 === "connecting";
}
function _temp$1(t0) {
  const {
    status
  } = t0;
  return status === "connected";
}
const LiveQueries = lazy(() => import("./LiveQueries.mjs")), PostMessageDocuments = lazy(() => import("./PostMessageDocuments.mjs")), PostMessageRefreshMutations = lazy(() => import("./PostMessageRefreshMutations.mjs")), PostMessagePerspective = lazy(() => import("./PostMessagePerspective.mjs")), PostMessagePreviewSnapshots = lazy(() => import("./PostMessagePreviewSnapshots.mjs")), PostMessageSchema = lazy(() => import("./PostMessageSchema.mjs")), PostMessageTelemetry = lazy(() => import("./PostMessageTelemetry.mjs")), Container = styled(Flex)`
  overflow-x: auto;
`;
function PresentationTool(props) {
  const {
    canCreateUrlPreviewSecrets,
    canToggleSharePreviewAccess,
    canUseSharedPreviewAccess,
    tool,
    vercelProtectionBypass
  } = props, components = tool.options?.components, _previewUrl = tool.options?.previewUrl, name = tool.name || DEFAULT_TOOL_NAME, {
    unstable_navigator,
    unstable_header
  } = components || {}, {
    navigate: routerNavigate,
    state: routerState
  } = useRouter(), routerSearchParams = useUnique(Object.fromEntries(routerState._searchParams || [])), {
    perspectiveStack,
    selectedPerspectiveName = "previewDrafts",
    selectedReleaseId
  } = usePerspective(), perspective = selectedReleaseId ? perspectiveStack : selectedPerspectiveName, initialPreviewUrl = usePreviewUrl(_previewUrl || "/", name, perspective, routerSearchParams.preview || null, canCreateUrlPreviewSecrets), canSharePreviewAccess = useMemo(() => _previewUrl && typeof _previewUrl == "object" && "draftMode" in _previewUrl && _previewUrl.draftMode ? (console.warn("previewUrl.draftMode is deprecated, use previewUrl.previewMode instead"), _previewUrl.draftMode.shareAccess !== !1) : _previewUrl && typeof _previewUrl == "object" && "previewMode" in _previewUrl && _previewUrl.previewMode ? _previewUrl.previewMode.shareAccess !== !1 : !1, [_previewUrl]), [devMode] = useState(() => {
    const option = tool.options?.devMode;
    return typeof option == "function" ? option() : typeof option == "boolean" ? option : typeof window < "u" && window.location.hostname === "localhost";
  }), targetOrigin = useMemo(() => initialPreviewUrl.origin, [initialPreviewUrl.origin]), iframeRef = useRef(null), [controller, setController] = useState(), [visualEditingComlink, setVisualEditingComlink] = useState(null), frameStateRef = useRef({
    title: void 0,
    url: void 0
  }), {
    navigate: _navigate,
    navigationHistory,
    params,
    searchParams,
    structureParams
  } = useParams({
    initialPreviewUrl,
    routerNavigate,
    routerState,
    routerSearchParams,
    frameStateRef
  }), navigate = useMemo(() => debounce(_navigate, 50), [_navigate]), [state, dispatch] = useReducer(presentationReducer, {}, presentationReducerInit), viewport = useMemo(() => params.viewport ? "mobile" : "desktop", [params.viewport]), [documentsOnPage, setDocumentsOnPage] = useDocumentsOnPage(perspective, frameStateRef), projectId = useProjectId(), dataset = useDataset(), mainDocumentState = useMainDocument({
    // Prevent flash of content by using immediate navigation
    navigate: _navigate,
    navigationHistory,
    path: params.preview,
    previewUrl: tool.options?.previewUrl,
    resolvers: tool.options?.resolve?.mainDocuments
  }), [overlaysConnection, setOverlaysConnection] = useStatus(), [loadersConnection, setLoadersConnection] = useStatus(), [previewKitConnection, setPreviewKitConnection] = useStatus(), {
    open: handleOpenPopup
  } = usePopups(controller), isLoading = state.iframe.status === "loading";
  useEffect(() => {
    const target = iframeRef.current?.contentWindow;
    if (!target || isLoading) return;
    const controller_0 = createController({
      targetOrigin
    });
    return controller_0.addTarget(target), setController(controller_0), () => {
      controller_0.destroy(), setController(void 0);
    };
  }, [targetOrigin, isLoading]);
  const handleNavigate = useEffectEvent((nextState, nextSearchState, forceReplace) => navigate(nextState, nextSearchState, forceReplace));
  useEffect(() => {
    if (!controller) return;
    const comlink = controller.createChannel({
      name: "presentation",
      heartbeat: !0,
      connectTo: "visual-editing"
    }, createConnectionMachine().provide({
      actors: createCompatibilityActors()
    }));
    comlink.on("visual-editing/focus", (data) => {
      "id" in data && handleNavigate({
        type: data.type,
        id: data.id,
        path: data.path
      });
    }), comlink.on("visual-editing/navigate", (data_0) => {
      const {
        title,
        url
      } = data_0;
      if (frameStateRef.current.url !== url)
        try {
          const [urlWithoutSearch, search] = url.split("?"), searchParams_0 = new URLSearchParams(search);
          searchParams_0.delete(urlSearchParamVercelProtectionBypass), searchParams_0.delete(urlSearchParamVercelSetBypassCookie), handleNavigate({}, {
            preview: `${urlWithoutSearch}${searchParams_0.size > 0 ? "?" : ""}${searchParams_0}`
          });
        } catch {
          handleNavigate({}, {
            preview: url
          });
        }
      frameStateRef.current = {
        title,
        url
      };
    }), comlink.on("visual-editing/meta", (data_1) => {
      frameStateRef.current.title = data_1.title;
    }), comlink.on("visual-editing/toggle", (data_2) => {
      dispatch({
        type: ACTION_VISUAL_EDITING_OVERLAYS_TOGGLE,
        enabled: data_2.enabled
      });
    }), comlink.on("visual-editing/documents", (data_3) => {
      setDocumentsOnPage(
        "visual-editing",
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        data_3.perspective,
        data_3.documents
      );
    }), comlink.on("visual-editing/refreshing", (data_4) => {
      data_4.source === "manual" ? clearTimeout(refreshRef.current) : data_4.source === "mutation" && dispatch({
        type: ACTION_IFRAME_REFRESH
      });
    }), comlink.on("visual-editing/refreshed", () => {
      dispatch({
        type: ACTION_IFRAME_LOADED
      });
    }), comlink.onStatus(setOverlaysConnection);
    const stop = comlink.start();
    return setVisualEditingComlink(comlink), () => {
      stop(), setVisualEditingComlink(null);
    };
  }, [controller, handleNavigate, setDocumentsOnPage, setOverlaysConnection, targetOrigin]), useEffect(() => {
    if (!controller) return;
    const comlink_0 = controller.createChannel({
      name: "presentation",
      connectTo: "preview-kit",
      heartbeat: !0
    }, createConnectionMachine().provide({
      actors: createCompatibilityActors()
    }));
    return comlink_0.onStatus(setPreviewKitConnection), comlink_0.on("preview-kit/documents", (data_5) => {
      data_5.projectId === projectId && data_5.dataset === dataset && setDocumentsOnPage(
        "preview-kit",
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        data_5.perspective,
        data_5.documents
      );
    }), comlink_0.start();
  }, [controller, dataset, projectId, setDocumentsOnPage, setPreviewKitConnection, targetOrigin]);
  const handleFocusPath = useCallback((nextPath) => {
    navigate({
      path: studioPath.toString(nextPath)
    }, {}, !0);
  }, [navigate]), handlePreviewPath = useCallback((nextPath_0) => {
    const url_0 = new URL(nextPath_0, initialPreviewUrl.origin), preview = url_0.pathname + url_0.search;
    url_0.origin === initialPreviewUrl.origin && preview !== params.preview && navigate({}, {
      preview
    });
  }, [initialPreviewUrl, params, navigate]), handleStructureParams = useCallback((structureParams_0) => {
    navigate({}, structureParams_0);
  }, [navigate]);
  useEffect(() => {
    params.id && params.path ? visualEditingComlink?.post("presentation/focus", {
      id: params.id,
      path: params.path
    }) : visualEditingComlink?.post("presentation/blur");
  }, [params.id, params.path, visualEditingComlink]), useEffect(() => {
    frameStateRef.current.url && params.preview && frameStateRef.current.url !== params.preview && (frameStateRef.current.url = params.preview, overlaysConnection !== "connected" && iframeRef.current ? iframeRef.current.src = `${targetOrigin}${params.preview}` : visualEditingComlink?.post("presentation/navigate", {
      url: params.preview,
      type: "replace"
    }));
  }, [overlaysConnection, targetOrigin, params.preview, visualEditingComlink]);
  const toggleOverlay = useCallback(() => visualEditingComlink?.post("presentation/toggle-overlay"), [visualEditingComlink]), [displayedDocument, setDisplayedDocument] = useState(null);
  useEffect(() => {
    const handleKeyUp = (e) => {
      isAltKey(e) && toggleOverlay();
    }, handleKeydown = (e_0) => {
      isAltKey(e_0) && toggleOverlay(), isHotkey(["mod", "\\"], e_0) && toggleOverlay();
    };
    return window.addEventListener("keydown", handleKeydown), window.addEventListener("keyup", handleKeyUp), () => {
      window.removeEventListener("keydown", handleKeydown), window.removeEventListener("keyup", handleKeyUp);
    };
  }, [toggleOverlay]);
  const [boundaryElement, setBoundaryElement] = useState(null), [{
    navigatorEnabled,
    toggleNavigator
  }, PresentationNavigator] = usePresentationNavigator({
    unstable_navigator
  }), refreshRef = useRef(void 0), handleRefresh = useCallback((fallback) => {
    if (dispatch({
      type: ACTION_IFRAME_REFRESH
    }), visualEditingComlink) {
      refreshRef.current = window.setTimeout(fallback, 300), visualEditingComlink.post("presentation/refresh", {
        source: "manual",
        livePreviewEnabled: previewKitConnection === "connected" || loadersConnection === "connected"
      });
      return;
    }
    fallback();
  }, [loadersConnection, previewKitConnection, visualEditingComlink]), workspace = useWorkspace(), getCommentIntent = useCallback(({
    id,
    type,
    path
  }) => {
    if (frameStateRef.current.url)
      return {
        title: frameStateRef.current.title || frameStateRef.current.url,
        name: "edit",
        params: {
          id,
          path,
          type,
          inspect: COMMENTS_INSPECTOR_NAME,
          workspace: workspace.name,
          mode: EDIT_INTENT_MODE,
          preview: params.preview
        }
      };
  }, [params.preview, workspace.name]), setViewport = useCallback((next) => {
    navigate({}, {
      viewport: next === "desktop" ? void 0 : "mobile"
    }, !0);
  }, [navigate]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(PresentationProvider, { devMode, name, navigate, params, searchParams, structureParams, children: /* @__PURE__ */ jsx(PresentationNavigateProvider, { navigate, children: /* @__PURE__ */ jsx(PresentationParamsProvider, { params, children: /* @__PURE__ */ jsx(SharedStateProvider, { comlink: visualEditingComlink, children: /* @__PURE__ */ jsx(Container, { height: "fill", children: /* @__PURE__ */ jsxs(Panels, { children: [
      /* @__PURE__ */ jsx(PresentationNavigator, {}),
      /* @__PURE__ */ jsx(Panel, { id: "preview", minWidth: 325, defaultSize: navigatorEnabled ? 50 : 75, order: 3, children: /* @__PURE__ */ jsx(Flex, { direction: "column", flex: 1, height: "fill", ref: setBoundaryElement, children: /* @__PURE__ */ jsx(BoundaryElementProvider, { element: boundaryElement, children: /* @__PURE__ */ jsx(
        Preview,
        {
          canSharePreviewAccess,
          canToggleSharePreviewAccess,
          canUseSharedPreviewAccess,
          dispatch,
          header: unstable_header,
          iframe: state.iframe,
          initialUrl: initialPreviewUrl,
          loadersConnection,
          navigatorEnabled,
          onPathChange: handlePreviewPath,
          onRefresh: handleRefresh,
          openPopup: handleOpenPopup,
          overlaysConnection,
          previewUrl: params.preview,
          perspective,
          ref: iframeRef,
          setViewport,
          targetOrigin,
          toggleNavigator,
          toggleOverlay,
          viewport,
          visualEditing: state.visualEditing,
          vercelProtectionBypass
        },
        targetOrigin
      ) }) }) }),
      /* @__PURE__ */ jsx(PresentationContent, { documentId: params.id, documentsOnPage, documentType: params.type, getCommentIntent, mainDocumentState, onFocusPath: handleFocusPath, onStructureParams: handleStructureParams, searchParams, setDisplayedDocument, structureParams })
    ] }) }) }) }) }) }),
    /* @__PURE__ */ jsxs(Suspense, { children: [
      controller && /* @__PURE__ */ jsx(LiveQueries, { controller, perspective, liveDocument: displayedDocument, onDocumentsOnPage: setDocumentsOnPage, onLoadersConnection: setLoadersConnection }),
      visualEditingComlink && params.id && params.type && /* @__PURE__ */ jsx(PostMessageRefreshMutations, { comlink: visualEditingComlink, id: params.id, type: params.type, loadersConnection, previewKitConnection }),
      visualEditingComlink && /* @__PURE__ */ jsx(PostMessageSchema, { comlink: visualEditingComlink, perspective }),
      visualEditingComlink && documentsOnPage.length > 0 && /* @__PURE__ */ jsx(PostMessagePreviewSnapshots, { comlink: visualEditingComlink, perspective, refs: documentsOnPage }),
      visualEditingComlink && /* @__PURE__ */ jsx(PostMessageDocuments, { comlink: visualEditingComlink, perspective }),
      visualEditingComlink && /* @__PURE__ */ jsx(PostMessageFeatures$1, { comlink: visualEditingComlink }),
      visualEditingComlink && /* @__PURE__ */ jsx(PostMessagePerspective, { comlink: visualEditingComlink, perspective }),
      visualEditingComlink && /* @__PURE__ */ jsx(PostMessageTelemetry, { comlink: visualEditingComlink })
    ] })
  ] });
}
function isAltKey(event) {
  return event.key === "Alt";
}
const IS_MAC = typeof window < "u" && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform), MODIFIERS = {
  alt: "altKey",
  ctrl: "ctrlKey",
  mod: IS_MAC ? "metaKey" : "ctrlKey",
  shift: "shiftKey"
};
function isHotkey(keys, event) {
  return keys.every((key) => MODIFIERS[key] ? event[MODIFIERS[key]] : event.key === key.toUpperCase());
}
function useVercelBypassSecret() {
  const $ = c(7);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    apiVersion: API_VERSION
  }, $[0] = t0) : t0 = $[0];
  const client = useClient(t0), [vercelProtectionBypassReadyState, ready] = useReducer(_temp, "loading"), [vercelProtectionBypassSecret, setVercelProtectionBypassSecret] = useState(null);
  let t1, t2;
  $[1] !== client ? (t1 = () => {
    const unsubscribe = subcribeToVercelProtectionBypass(client, (secret) => {
      setVercelProtectionBypassSecret(secret), ready();
    });
    return () => unsubscribe();
  }, t2 = [client], $[1] = client, $[2] = t1, $[3] = t2) : (t1 = $[2], t2 = $[3]), useEffect(t1, t2);
  let t3;
  return $[4] !== vercelProtectionBypassReadyState || $[5] !== vercelProtectionBypassSecret ? (t3 = [vercelProtectionBypassSecret, vercelProtectionBypassReadyState], $[4] = vercelProtectionBypassReadyState, $[5] = vercelProtectionBypassSecret, $[6] = t3) : t3 = $[6], t3;
}
function _temp() {
  return "ready";
}
function PresentationToolGrantsCheck(props) {
  const $ = c(17), {
    t
  } = useTranslation(presentationLocaleNamespace), {
    previewUrl
  } = props.tool.options ?? {}, {
    push: pushToast
  } = useToast(), willGeneratePreviewUrlSecret = typeof previewUrl == "object" || typeof previewUrl == "function", grantsStore = useGrantsStore(), [previewAccessSharingCreatePermission, setCreateAccessSharingPermission] = useState(null), [previewAccessSharingUpdatePermission, setUpdateAccessSharingPermission] = useState(null), [previewAccessSharingReadPermission, setReadAccessSharingPermission] = useState(null), [previewUrlSecretPermission, setPreviewUrlSecretPermission] = useState(null);
  let t0, t1;
  $[0] !== grantsStore || $[1] !== willGeneratePreviewUrlSecret ? (t0 = () => {
    if (!willGeneratePreviewUrlSecret)
      return;
    const previewCreateAccessSharingPermissionSubscription = grantsStore.checkDocumentPermission("create", {
      _id: schemaIdSingleton,
      _type: schemaTypeSingleton
    }).subscribe(setCreateAccessSharingPermission), previewUpdateAccessSharingPermissionSubscription = grantsStore.checkDocumentPermission("update", {
      _id: schemaIdSingleton,
      _type: schemaTypeSingleton
    }).subscribe(setUpdateAccessSharingPermission), previewReadAccessSharingPermissionSubscription = grantsStore.checkDocumentPermission("read", {
      _id: schemaIdSingleton,
      _type: schemaTypeSingleton
    }).subscribe(setReadAccessSharingPermission), previewUrlSecretPermissionSubscription = grantsStore.checkDocumentPermission("create", {
      _id: `drafts.${uuid()}`,
      _type: schemaType
    }).subscribe(setPreviewUrlSecretPermission);
    return () => {
      previewCreateAccessSharingPermissionSubscription.unsubscribe(), previewUpdateAccessSharingPermissionSubscription.unsubscribe(), previewReadAccessSharingPermissionSubscription.unsubscribe(), previewUrlSecretPermissionSubscription.unsubscribe();
    };
  }, t1 = [grantsStore, willGeneratePreviewUrlSecret], $[0] = grantsStore, $[1] = willGeneratePreviewUrlSecret, $[2] = t0, $[3] = t1) : (t0 = $[2], t1 = $[3]), useEffect(t0, t1);
  const canCreateUrlPreviewSecrets = previewUrlSecretPermission?.granted;
  let t2, t3;
  $[4] !== canCreateUrlPreviewSecrets || $[5] !== pushToast || $[6] !== t || $[7] !== willGeneratePreviewUrlSecret ? (t2 = () => {
    if (!willGeneratePreviewUrlSecret || canCreateUrlPreviewSecrets !== !1)
      return;
    const raf = requestAnimationFrame(() => pushToast({
      closable: !0,
      status: "error",
      duration: 3e4,
      title: t("preview-url-secret.missing-grants")
    }));
    return () => cancelAnimationFrame(raf);
  }, t3 = [canCreateUrlPreviewSecrets, pushToast, t, willGeneratePreviewUrlSecret], $[4] = canCreateUrlPreviewSecrets, $[5] = pushToast, $[6] = t, $[7] = willGeneratePreviewUrlSecret, $[8] = t2, $[9] = t3) : (t2 = $[8], t3 = $[9]), useEffect(t2, t3);
  const [vercelProtectionBypass, vercelProtectionBypassReadyState] = useVercelBypassSecret();
  if (vercelProtectionBypassReadyState === "loading" || willGeneratePreviewUrlSecret && (!previewAccessSharingCreatePermission || typeof previewAccessSharingCreatePermission.granted > "u" || !previewAccessSharingUpdatePermission || typeof previewAccessSharingUpdatePermission.granted > "u" || !previewUrlSecretPermission || !previewAccessSharingReadPermission || typeof previewAccessSharingReadPermission.granted > "u" || typeof previewUrlSecretPermission.granted > "u")) {
    let t42;
    return $[10] === Symbol.for("react.memo_cache_sentinel") ? (t42 = /* @__PURE__ */ jsx(PresentationSpinner, {}), $[10] = t42) : t42 = $[10], t42;
  }
  const t4 = canCreateUrlPreviewSecrets === !0, t5 = previewAccessSharingCreatePermission?.granted === !0 && previewAccessSharingUpdatePermission?.granted === !0, t6 = previewAccessSharingReadPermission?.granted === !0;
  let t7;
  return $[11] !== props || $[12] !== t4 || $[13] !== t5 || $[14] !== t6 || $[15] !== vercelProtectionBypass ? (t7 = /* @__PURE__ */ jsx(PresentationTool, { ...props, vercelProtectionBypass, canCreateUrlPreviewSecrets: t4, canToggleSharePreviewAccess: t5, canUseSharedPreviewAccess: t6 }), $[11] = props, $[12] = t4, $[13] = t5, $[14] = t6, $[15] = vercelProtectionBypass, $[16] = t7) : t7 = $[16], t7;
}
export {
  PresentationToolGrantsCheck as default
};
//# sourceMappingURL=PresentationToolGrantsCheck.mjs.map
